import React, { useEffect, useState, useRef, useMemo } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import Select from 'react-select';
import { ToastContainer, toast } from "react-toastify";
import { AddwithBlueCircle, AddwithWhiteCircle, CloudUpload, CrosswithGreyCircle, CrosswithRedCircle, DeleteDustbin, Eye, Printer, UpdatePencil } from "../../AllSvg";
import ReactQuill from "react-quill";
import { BASE_URL } from "../../../config/axios";
import { handleErrorToast, renderDangerousHTML, ReorderList } from "../../CustomFunctions";
import { customSortByKey } from "../../CustomFunctions";
import ReactToPrint from "react-to-print";
import { ViewFile } from "../../CustomFunctions";
import Loader from "../../Loader";
import { CSSForSelect, QuillEditorFormats, QuillEditorModules } from "../../CustomUtilities";
import { ViewLetterBuilder } from "../LetterBuilderManagement/LetterTemplateComponentsTesting";
import { LetterPreview } from "../LetterDisplayComponents/LetterPreview";

const AddSlipBuilderCategory = ({ getSlipBuilderCategories, SUB_COMPANIES, SUPER_ADMIN }) => {
  const [show, setShow] = useState(false)
  const handleShow = () => {
    setShow(true);
  }

  const handleClose = () => {
    setShow(false);
    setFormData({
      other_name: "",
      sub_company: sessionStorage.getItem('company_id'),
    })
  }

  const initialData = {
    sub_company: sessionStorage.getItem("company_id"),
    code: "",
    name: "",
    description: "",
  }

  const [formData, setFormData] = useState(initialData);
  const [inputState, setInputState] = useState({});
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const validateForm = () => {
    const newErrors = {};
    let requiredFields = [
      "sub_company",
      "code",
      "name",
      "description",
    ]

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
      }
    })

    setErrors(newErrors);
    setIsSubmitted(true);
    return Object.keys(newErrors).length === 0;

  };


  const handleSubmitData = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoading(true);
      const loadingToastId = toast.loading("Loading: Please Wait....");

      try {
        const payload = {
          ...formData,
          code: formData.code
            .trim()
            .replace(/\s+/g, "-")
            .toLowerCase()
        };
        let res = await axios.post(`${BASE_URL}/wfm/slip-category-dynamic/`, payload);
        if (res.status === 200 || res.status === 201) {
          await getSlipBuilderCategories();
          setShow(false);
          setFormData(initialData);
          toast.success("Slip Builder Category Added Successfully!")
        }
      } catch (error) {
        handleErrorToast(error, loadingToastId);
      } finally {
        setLoading(false);
        toast.dismiss(loadingToastId);
      }
    }
  }

  const subcompanyOption = SUB_COMPANIES.sort((a, b) => b.title.localeCompare(a.title)).map((i) => ({
    value: i.id,
    label: i.title
  }))

  const handleCompanyChange = (selectedOption) => {
    if (!selectedOption) {
      setFormData({
        ...formData,
        sub_company: "",
      })

    } else {
      setFormData({
        ...formData,
        sub_company: selectedOption.value,
      })
    }

    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors.sub_company;
      return updatedErrors;
    });

  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let newValue = value;

    // if (name === "slip_category_code") {
    //   newValue = newValue.trim().replace(/\s+/g, "-").toLowerCase()
    // }
    if (name === "name") {
      const codeValue = value.trim().replace(/\s+/g, "-").toLowerCase();

      setFormData({
        ...formData,
        name: value,
        code: codeValue,
      });
    }
    else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });



    if (value.trim()) {
      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[name];
        return updatedErrors;
      });
    }
  };

  return (
    <>
      <button className='upload-svg' title='Add Slip Builder Category' onClick={handleShow}>
        <AddwithWhiteCircle /> Slip Builder Categories
      </button>
      <Modal show={show} onHide={handleClose} dialogClassName='request-leave width-40vw'>
        <Modal.Header className='justify-center task-Tab-heading font-weight500    font-size-heading ' closeButton>
          <Modal.Title>
            Add Slip Builder Category
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div>
              <div className="flex-row mb-2 gap-2">
                <label
                  htmlFor="code"
                  className="form-labels font-weight500 font-size-subheading"
                >
                  Code :
                </label>
                <span className="mt-1">{formData.code}</span>
              </div>



              {SUPER_ADMIN && <div className="flex-column">
                <div>
                  <label htmlFor="sub_company" className="form-labels font-weight500 announce-date font-size-heading">
                    Select Sub Company<span className="required">*</span>
                  </label>
                  <Select
                    options={subcompanyOption}
                    onChange={handleCompanyChange}
                    value={subcompanyOption.find(option => option.value === formData.sub_company)}
                    placeholder="Select SubCompany"
                    isSearchable
                    isClearable
                    noOptionsMessage={() => "No other options"}
                    styles={CSSForSelect}
                  />
                </div>
                {errors.sub_company && (
                  <div className="error-message font-size-text">{errors.sub_company}</div>

                )}
              </div>
              }

              {/* <div className="flex-column">
                <label
                  htmlFor="code"
                  className="form-labels font-weight500 font-size-subheading"
                >
                  Code<span className="required">*</span>
                </label>
                <input
                  type="text"
                  id="code"
                  name="code"
                  maxLength={150}
                  onChange={handleInputChange}
                  value={formData.code}
                  className={`form-input form-input-background  ${errors.code
                    ? "error"
                    : inputState.code
                      ? "success"
                      : ""
                    }`
                  }
                />
                {errors.code && (
                  <span className="error-message font-size-text">
                    {errors.code}
                  </span>
                )}
              </div> */}

              <div className="flex-column">
                <label
                  htmlFor="name"
                  className="form-labels font-weight500 font-size-subheading"
                >
                  Name<span className="required">*</span>
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  maxLength={150}
                  onChange={handleInputChange}
                  value={formData.name}
                  className={`form-input form-input-background  ${errors.name
                    ? "error"
                    : inputState.name
                      ? "success"
                      : ""
                    }`
                  }
                />
                {errors.name && (
                  <span className="error-message font-size-text">
                    {errors.name}
                  </span>
                )}
              </div>

              <div className="flex-column">
                <label htmlFor="description" className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
                  Description<span className="required">*</span>
                </label>
                <textarea
                  id="description"
                  type="text"
                  name="description"
                  onChange={handleInputChange}
                  value={formData.description}
                  className={`form-input-textarea   font-weight400  font-size-subheading  ${errors.description
                    ? "error"
                    : inputState.description
                      ? "success"
                      : ""
                    }
                   `}
                />
                {errors.description && (
                  <span className="error-message font-size-text ">{errors.description}</span>
                )}
              </div>


              <div className="button-models">
                <button
                  type="button"
                  className="model-button model-button-cancel font-weight500"
                  onClick={handleClose}>
                  Cancel
                </button>
                <button
                  type="submit"
                  className="model-button model-button-leave font-weight500 font-size-heading"
                  onClick={handleSubmitData}
                  disabled={loading}
                >
                  Submit
                </button>
              </div>

              <p className="error-message font-size-text">
                {isSubmitted && Object.keys(errors).length > 0 && (
                  Object.keys(errors).length > 5 ? (
                    <h5 className="text-center">Please fill all mandatory fields!</h5>
                  ) : (
                    <h6 className="text-center">
                      {Object.keys(errors).map((field) =>
                        field.charAt(0).toUpperCase() + field.slice(1)
                      ).join(', ') + ' are required!'}
                    </h6>
                  )
                )}
              </p>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
    </>
  )

}

const UpdateSlipBuilderCategory = ({ i, getSlipBuilderCategories, SUB_COMPANIES, SUPER_ADMIN }) => {
  const [show, setShow] = useState(false);

  const handleShow = () => {
    setShow(true);
  }

  const handleClose = () => {
    setShow(false);
  }

  const [inputState, setInputState] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    sub_company: sessionStorage.getItem("company_id"),
    code: "",
    name: "",
    description: "",
    updated_by: sessionStorage.getItem('emp_code'),
  });

  useEffect(() => {
    setFormData(i);
  }, [i]);

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      "sub_company",
      "code",
      "name",
      "description",
    ]

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
      }
    })

    setErrors(newErrors);
    setIsSubmitted(true);
    return Object.keys(newErrors).length === 0;
  };


  const handleSubmitData = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      const loadingToastId = toast.loading("Loading: Please Wait....");
      setLoading(true);
      try {
        const payload = {
          ...formData,
          code: formData.code
            .trim()
            .replace(/\s+/g, "-")
            .toLowerCase()
        };
        let res = await axios.put(`${BASE_URL}/wfm/slip-category-dynamic-update/${i.id}/`, payload);
        if (res.status === 200) {
          await getSlipBuilderCategories();
          setShow(false);
          toast.success('Slip Builder Category Updated Successfully!')
        }
      } catch (error) {
        handleErrorToast(error, loadingToastId);
      } finally {
        setLoading(false);
        toast.dismiss(loadingToastId);
      }
    }
  }
  const subcompanyOption = SUB_COMPANIES.sort((a, b) => b.title.localeCompare(a.title)).map((i) => ({
    value: i.id,
    label: i.title
  }))

  const handleCompanyChange = (selectedOption) => {
    if (!selectedOption) {
      setFormData({
        ...formData,
        sub_company: "",
      })

    } else {
      setFormData({
        ...formData,
        sub_company: selectedOption.value,
      })
    }

    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors.sub_company;
      return updatedErrors;
    });

  }


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let newValue = value;

    if (name === "name") {
      const codeValue = value.trim().replace(/\s+/g, "-").toLowerCase();
      setFormData({
        ...formData,
        name: value,
        code: codeValue,
      });
    }
    else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });



    if (value.trim()) {
      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[name];
        return updatedErrors;
      });
    }
  };

  return (
    <>
      <button className='model-edit-button-ml' title='Update Slip Builder Category' onClick={handleShow}>
        <UpdatePencil />
      </button>
      <Modal show={show} onHide={handleClose} dialogClassName='request-leave width-40vw'>
        <Modal.Header className='justify-center task-Tab-heading font-weight500    font-size-heading ' closeButton>
          <Modal.Title>
            Update Slip Builder Category
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div>
              <div className="flex-row mb-2 gap-2">
                <label
                  htmlFor="code"
                  className="form-labels font-weight500 font-size-subheading"
                >
                  Code :
                </label>
                <span className="mt-1">{formData.code}</span>
              </div>

              {SUPER_ADMIN && <div className="flex-column">
                <div>
                  <label htmlFor="sub_company" className="form-labels font-weight500 announce-date font-size-heading">
                    Select Sub Company<span className="required">*</span>
                  </label>
                  <Select
                    options={subcompanyOption}
                    onChange={handleCompanyChange}
                    value={subcompanyOption.find(option => option.value === formData.sub_company)}
                    placeholder="Select SubCompany"
                    isSearchable
                    isClearable
                    noOptionsMessage={() => "No other options"}
                    styles={CSSForSelect}
                  />
                </div>
                {errors.sub_company && (
                  <div className="error-message font-size-text">{errors.sub_company}</div>

                )}
              </div>}



              <div className="flex-column">
                <label
                  htmlFor="name"
                  className="form-labels font-weight500 font-size-subheading"
                >
                  Name<span className="required">*</span>
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  style={{ cursor: SUPER_ADMIN ? 'auto' : 'not-allowed' }}
                  disabled={!SUPER_ADMIN}
                  maxLength={150}
                  onChange={handleInputChange}
                  value={formData.name}
                  className={`form-input form-input-background  ${errors.name
                    ? "error"
                    : inputState.name
                      ? "success"
                      : ""
                    }`
                  }
                />
                {errors.name && (
                  <span className="error-message font-size-text">
                    {errors.name}
                  </span>
                )}
              </div>

              <div className="flex-column">
                <label htmlFor="description" className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
                  Description<span className="required">*</span>
                </label>
                <textarea
                  id="description"
                  type="text"
                  name="description"
                  onChange={handleInputChange}
                  value={formData.description}
                  className={`form-input-textarea   font-weight400  font-size-subheading  ${errors.description
                    ? "error"
                    : inputState.description
                      ? "success"
                      : ""
                    }
                   `}
                />
                {errors.description && (
                  <span className="error-message font-size-text ">{errors.description}</span>
                )}
              </div>

              <div className="button-models">
                <button
                  type="button"
                  className="model-button model-button-cancel font-weight500"
                  onClick={handleClose}>
                  Cancel
                </button>
                <button
                  type="submit"
                  className="model-button model-button-leave font-weight500 font-size-heading"
                  onClick={handleSubmitData}
                  disabled={loading}
                >
                  Update
                </button>
              </div>

              <p className="error-message font-size-text">
                {isSubmitted && Object.keys(errors).length > 0 && (
                  Object.keys(errors).length > 5 ? (
                    <h5 className="text-center">Please fill all mandatory fields!</h5>
                  ) : (
                    <h6 className="text-center">
                      {Object.keys(errors).map((field) =>
                        field.charAt(0).toUpperCase() + field.slice(1)
                      ).join(', ') + ' are required!'}
                    </h6>
                  )
                )}
              </p>
            </div>
          </div>
        </Modal.Body>
        <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      </Modal>
    </>
  )
}

const DeleteSlipBuilderCategory = ({ i, getSlipBuilderCategories }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  };
  const [loading, setLoading] = useState(false);

  const handleFormSubmitDelete = async (e) => {
    e.preventDefault();
    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
    try {
      let res = await axios.delete(
        `${BASE_URL}/wfm/slip-category-dynamic-update/${i?.id}/`
      );

      if (res.status === 200) {
        await getSlipBuilderCategories();
        setShow(false);
        toast.success("Slip Builder Category Deleted Successfully");
      } else {
        console.error(res);
      }
    } catch (err) {
      //toast Logic
      handleErrorToast(err, loadingToastId);
    } finally {
      setLoading(false);
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      <button
        title="Delete Slip Builder Category"
        className="model-delete-button"
        onClick={handleShow}
      >
        <DeleteDustbin />
      </button>
      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Slip Builder Category</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            Are You Sure You Want to delete the "{i?.name}" slip builder category
            <div className="button-models">
              <button
                className="model-button model-button-cancel font-weight500"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                onClick={handleFormSubmitDelete}
                className="model-button model-button-delete font-weight500"
                disabled={loading}
              >
                Delete
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

    </>
  );
};

const AddSlipBuildDetailsBackup = ({
  SUB_COMPANIES,
  SUPER_ADMIN,
  getSlipBuilderData,
  SLIP_CATEGORIES,
  LETTER_TEMPLATES,
  AUTHORITY_USERS,
  empList,

}) => {


  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);


  const initialFormData = {
    name: "",
    description: "",
    is_default: false,
    sub_company: sessionStorage.getItem("company_id"),
    letter_template: "",
    category_id: "",
    starter_display: false,
    body_display: false,
    ender_display: false,


    sections: [
      {
        section_type: "starter",
        order: 1,
        title: "",
        compartments: [
          {
            layout_type: "full",
            order: 1,
            fields: []
          }
        ]
      },
      {
        section_type: "body",
        order: 2,
        title: "",
        compartments: [
          {
            layout_type: "full",
            columns: 2,
            order: 1,
            fields: []
          }
        ]
      },
      {
        section_type: "ender",
        order: 3,
        title: "",
        compartments: [],

        ender_config: {
          ender_type: "default",
          note_text: "",
          show_for_name: false,
          for_name: "",
          for_name_position: "top",
          for_name_alignment: "center",

          show_assigning_authority: false,
          signature_authority: "",// emp_code
          show_authority_name: false,
          show_authority_designation: false,

          authority_name_position: "bottom",
          authority_name_alignment: "left",

          authority_designation_position: "bottom",
          authority_designation_alignment: "left"
        }
      }
    ]
  };
  const [visibleSections, setVisibleSections] = useState({});

  const toggleFieldsVisibility = (sectionIndex) => {
    setVisibleSections(prev => ({
      ...prev,
      [sectionIndex]: !prev[sectionIndex],
    }));
  };
  const [formData, setFormData] = useState(initialFormData);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);



  const handleAuthorityToggle = (value, sectionIndex) => {
    setFormData(prev => {
      const updatedSections = [...prev.sections];
      const section = updatedSections[sectionIndex];

      if (section.section_type !== "ender") return prev;

      section.ender_config.show_assigning_authority_name = value === "show_assigning_authority_name";
      section.ender_config.show_authority_designation = value === "show_authority_designation";

      return {
        ...prev,
        sections: updatedSections
      };
    });
  };


  const validateForm = () => {
    const newErrors = {};
    const requiredFields = ["name", "category_id", "letter_template"];

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
      }
    });

    setErrors(newErrors);
    setIsSubmitted(true);
    return Object.keys(newErrors).length === 0;
  };


  // const handleChange = (e) => {
  //   const { name, value, type, checked } = e.target;

  //   if (name === "starter_display") {
  //     setFormData((prev) => {
  //       const updatedSections = prev.sections.map(section => {
  //         if (section.section_type === "starter") {
  //           return {
  //             ...section,
  //             title: "",
  //             compartments: [
  //               {
  //                 layout_type: "full",
  //                 order: 1,
  //                 fields: []
  //               }
  //             ]
  //           };
  //         }
  //         return section;
  //       });

  //       return {
  //         ...prev,
  //         starter_display: checked,
  //         sections: updatedSections
  //       };
  //     });
  //     return;
  //   }


  //   if (name === "body_display") {
  //     setFormData((prev) => {
  //       const updatedSections = prev.sections.map(section => {
  //         if (section.section_type === "body") {
  //           return {
  //             ...section,
  //             title: "",
  //             compartments: [
  //               {
  //                 layout_type: "",
  //                 columns: 2,
  //                 order: 1,
  //                 fields: []
  //               }
  //             ]
  //           };
  //         }
  //         return section;
  //       });

  //       return {
  //         ...prev,
  //         body_display: checked,
  //         sections: updatedSections
  //       };
  //     });
  //     return;
  //   }

  //   if (name === "ender_display") {
  //     setFormData((prev) => {
  //       const updatedSections = prev.sections.map(section => {
  //         if (section.section_type === "ender") {
  //           return {
  //             ...section,
  //             title: "",
  //             compartments: [],
  //             ender_config: {
  //               ender_type: "default",
  //               note_text: "",
  //               show_for_name: false,
  //               for_name: "",
  //               for_name_position: "top",
  //               for_name_alignment: "center",
  //               show_assigning_authority: false,
  //               signature_authority: "",
  //               show_authority_name: false,
  //               show_authority_designation: false,
  //               authority_name_position: "bottom",
  //               authority_name_alignment: "left",
  //               authority_designation_position: "bottom",
  //               authority_designation_alignment: "left"
  //             }
  //           };
  //         }
  //         return section;
  //       });

  //       return {
  //         ...prev,
  //         ender_display: checked,
  //         sections: updatedSections
  //       };
  //     });
  //     return;
  //   }







  //   setFormData(prev => ({
  //     ...prev,
  //     [name]: type === "checkbox" ? checked : value
  //   }));

  //   setInputState({
  //     ...inputState,
  //     [name]: value.trim() ? "green" : ""
  //   });

  //   if (value.trim()) {
  //     setErrors(prevErrors => {
  //       const updatedErrors = { ...prevErrors };
  //       delete updatedErrors[name];
  //       return updatedErrors;
  //     });
  //   }
  // };





  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;


    const displayToSection = {
      starter_display: "starter",
      body_display: "body",
      ender_display: "ender"
    };


    const getSectionTemplate = (type) => {
      switch (type) {
        case "starter":
          return {
            section_type: "starter",
            order: 1,
            title: "",
            compartments: [
              {
                layout_type: "full",
                order: 1,
                fields: []
              }
            ]
          };
        case "body":
          return {
            section_type: "body",
            order: 2,
            title: "",
            compartments: [
              {
                layout_type: "full",
                columns: 2,
                order: 1,
                fields: []
              }
            ]
          };
        case "ender":
          return {
            section_type: "ender",
            order: 3,
            title: "",
            compartments: [],
            ender_config: {
              ender_type: "default",
              note_text: "",
              show_for_name: false,
              for_name: "",
              for_name_position: "top",
              for_name_alignment: "center",
              show_assigning_authority: false,
              signature_authority: "",
              show_authority_name: false,
              show_authority_designation: false,
              authority_name_position: "bottom",
              authority_name_alignment: "left",
              authority_designation_position: "bottom",
              authority_designation_alignment: "left"
            }
          };
        default:
          return null;
      }
    };


    if (displayToSection[name]) {
      const sectionType = displayToSection[name];

      setFormData((prev) => {
        let newSections = checked
          ? [...prev.sections, getSectionTemplate(sectionType)].filter(
            (s, i, arr) =>
              arr.findIndex((sec) => sec.section_type === s.section_type) === i
          ) // ensure uniqueness
          : prev.sections.filter((s) => s.section_type !== sectionType);

        return {
          ...prev,
          [name]: checked,
          sections: newSections.length ? newSections : []
        };
      });
      return;
    }


    setFormData((prev) => {
      if (!prev.starter_display && !prev.body_display && !prev.ender_display) {
        return {
          ...prev,
          sections: [],
          [name]: type === "checkbox" ? checked : value
        };
      }

      return {
        ...prev,
        [name]: type === "checkbox" ? checked : value
      };
    });


    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : ""
    });

    if (value.trim()) {
      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[name];
        return updatedErrors;
      });
    }
  };



  const addSection = () => {
    setFormData(prev => {
      const updatedSections = [...prev.sections];

      updatedSections.push({
        section_type: "starter",
        order: updatedSections.length + 1,
        title: "",
        compartments: [
          {
            order: 1,
            layout_type: "full",
            fields: []
          }
        ],
        // ender_config: null
      });

      return {
        ...prev,
        sections: updatedSections
      };
    });
  };

  const handleSectionChange = (e, sectionIndex) => {
    const { name, value } = e.target;

    setFormData(prev => {
      const updatedSections = [...prev.sections];
      updatedSections[sectionIndex] = {
        ...updatedSections[sectionIndex],
        [name]: value
      };

      return {
        ...prev,
        sections: updatedSections
      };
    });
  };

  const removeSection = (sectionIndex) => {
    setFormData(prev => {
      const updatedSections = [...prev.sections];
      updatedSections.splice(sectionIndex, 1);

      // Reorder section order values
      updatedSections.forEach((section, index) => {
        section.order = index + 1;
      });

      return {
        ...prev,
        sections: updatedSections
      };
    });
  };


  // Add a new compartment to a section
  const addCompartment = (sectionIndex) => {
    setFormData(prev => {
      const updatedSections = [...prev.sections];
      const updatedCompartments = [...updatedSections[sectionIndex].compartments];

      updatedCompartments.push({
        order: updatedCompartments.length + 1,
        layout_type: "full",
        // columns: 2,
        fields: []
      });

      updatedSections[sectionIndex] = {
        ...updatedSections[sectionIndex],
        compartments: updatedCompartments
      };

      return {
        ...prev,
        sections: updatedSections
      };
    });
  };

  // Handle compartment change (layout_type, columns, etc.)
  const handleCompartmentChange = (e, sectionIndex, compartmentIndex) => {
    const { name, value } = e.target;

    setFormData(prev => {
      const updatedSections = [...prev.sections];
      const updatedCompartments = [...updatedSections[sectionIndex].compartments];

      updatedCompartments[compartmentIndex] = {
        ...updatedCompartments[compartmentIndex],
        [name]: name === "columns" ? parseInt(value) : value
      };

      updatedSections[sectionIndex] = {
        ...updatedSections[sectionIndex],
        compartments: updatedCompartments
      };

      return {
        ...prev,
        sections: updatedSections
      };
    });
  };

  // Remove compartment
  const removeCompartment = (sectionIndex, compartmentIndex) => {
    setFormData(prev => {
      const updatedSections = [...prev.sections];
      const updatedCompartments = [...updatedSections[sectionIndex].compartments];

      updatedCompartments.splice(compartmentIndex, 1);

      // Reorder compartments
      updatedCompartments.forEach((comp, index) => {
        comp.order = index + 1;
      });

      updatedSections[sectionIndex] = {
        ...updatedSections[sectionIndex],
        compartments: updatedCompartments
      };

      return {
        ...prev,
        sections: updatedSections
      };
    });
  };


  const addFieldToCompartment = (sectionIndex, compartmentIndex) => {
    setFormData(prev => {
      const updatedSections = [...prev.sections];
      const updatedCompartments = [...updatedSections[sectionIndex].compartments];
      const compartment = updatedCompartments[compartmentIndex];
      // const updatedFields = [...updatedCompartments[compartmentIndex].fields];
      const updatedFields = [...compartment.fields];

      let defaultColumn = 1;
      let defaultOrder = 1;

      if (compartment.layout_type === "columns") {
        // Find the column with the fewest fields for better distribution
        const columnCounts = {};
        updatedFields.forEach(field => {
          const col = field.column_position || 1;
          columnCounts[col] = (columnCounts[col] || 0) + 1;
        });



        // Use column 1 by default, or find column with least fields
        defaultColumn = 1;
        let minCount = columnCounts[1] || 0;
        for (let col = 2; col <= (compartment.columns || 2); col++) {
          const count = columnCounts[col] || 0;
          if (count < minCount) {
            minCount = count;
            defaultColumn = col;
          }
        }

        defaultOrder = (columnCounts[defaultColumn] || 0) + 1;
      } else {
        defaultOrder = updatedFields.length + 1;
      }

      updatedFields.push({
        label: "",
        label_alignment: "left",
        category: "",
        value_key: "",
        value_alignment: "left",
        order: defaultOrder,
        column_position: compartment.layout_type === "columns" ? defaultColumn : undefined
      });

      // updatedFields.push({
      //   label: "",
      //   label_alignment: "left",
      //   category: "",
      //   value_key: "",
      //   value_alignment: "left",
      //   order: updatedFields.length + 1
      // });

      updatedCompartments[compartmentIndex] = {
        ...updatedCompartments[compartmentIndex],
        fields: updatedFields
      };

      updatedSections[sectionIndex] = {
        ...updatedSections[sectionIndex],
        compartments: updatedCompartments
      };

      return {
        ...prev,
        sections: updatedSections
      };
    });
  };

  const handleFieldChange = (e, sectionIndex, compartmentIndex, fieldIndex) => {
    const { name, value } = e.target;

    setFormData(prev => {
      const updatedSections = [...prev.sections];
      const updatedCompartments = [...updatedSections[sectionIndex].compartments];
      const updatedFields = [...updatedCompartments[compartmentIndex].fields];
      const compartment = updatedCompartments[compartmentIndex];

      if (name === "column_position" && compartment.layout_type === "columns") {
        const newColumn = parseInt(value);
        const currentColumn = updatedFields[fieldIndex].column_position;

        // If moving to a different column, set order to last position in new column
        if (newColumn !== currentColumn) {
          // Count how many fields are already in the new column
          const fieldsInNewColumn = updatedFields.filter(
            (field, idx) => idx !== fieldIndex && field.column_position === newColumn
          ).length;

          updatedFields[fieldIndex] = {
            ...updatedFields[fieldIndex],
            [name]: newColumn,
            order: fieldsInNewColumn + 1 // Set to next available position in new column
          };
        } else {
          // Same column, just update the value
          updatedFields[fieldIndex] = {
            ...updatedFields[fieldIndex],
            [name]: newColumn
          };
        }
      } else {
        // For other field changes
        updatedFields[fieldIndex] = {
          ...updatedFields[fieldIndex],
          [name]: value
        };
      }

      // updatedFields[fieldIndex] = {
      //   ...updatedFields[fieldIndex],
      //   [name]: value
      // };

      updatedCompartments[compartmentIndex] = {
        ...updatedCompartments[compartmentIndex],
        fields: updatedFields
      };

      updatedSections[sectionIndex] = {
        ...updatedSections[sectionIndex],
        compartments: updatedCompartments
      };

      return {
        ...prev,
        sections: updatedSections
      };
    });
  };

  const removeField = (sectionIndex, compartmentIndex, fieldIndex) => {
    setFormData(prev => {
      const updatedSections = [...prev.sections];
      const updatedCompartments = [...updatedSections[sectionIndex].compartments];
      const updatedFields = [...updatedCompartments[compartmentIndex].fields];

      updatedFields.splice(fieldIndex, 1);

      // Update positions
      updatedFields.forEach((field, index) => {
        field.order = index + 1;
      });

      updatedCompartments[compartmentIndex] = {
        ...updatedCompartments[compartmentIndex],
        fields: updatedFields
      };

      updatedSections[sectionIndex] = {
        ...updatedSections[sectionIndex],
        compartments: updatedCompartments
      };

      return {
        ...prev,
        sections: updatedSections
      };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoading(true);

      const loadingToastId = toast.loading("Creating slip template...");

      try {
        let res = await axios.post(
          `${BASE_URL}/wfm/slip-builder/`,
          formData,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (res.status === 200 || res.status === 201) {
          await getSlipBuilderData();
          setShow(false);
          setFormData(initialFormData);
          toast.success("Slip template created successfully!");
        }
      } catch (err) {
        handleErrorToast(err, loadingToastId);
      } finally {
        setLoading(false);
        toast.dismiss(loadingToastId);
      }
    }
  };

  const sectionTypes = [
    { value: "starter", label: "Starter Section" },
    { value: "body", label: "Body Section" },
    { value: "ender", label: "Ender Section" }
  ];

  const layoutTypes = [
    { value: "full", label: "Full Width" },
    { value: "columns", label: "Multi Columns" }
  ];

  const alignmentChoices = [
    { value: "left", label: "Left" },
    { value: "center", label: "Center" },
    { value: "right", label: "Right" }
  ];

  const enderTypes = [
    { value: "signature", label: "Signature" },
    { value: "note", label: "Note" },
    { value: "default", label: "Default Message" }
  ];


  const handleEnderConfigChange = (e, sectionIndex) => {
    const { name, type, checked, value } = e.target;

    setFormData((prev) => {
      const updatedSections = prev.sections.map((section, idx) => {
        if (idx !== sectionIndex) return section;
        console.log('idx !== sectionIndex', idx !== sectionIndex)
        console.log('name', name)
        console.log('value', value)
        console.log('section.ender_config', section.ender_config)
        return {
          ...section,
          ender_config: {
            ...section.ender_config,
            [name]: type === "checkbox" ? checked : value
          }
        };
      });

      return {
        ...prev,
        sections: updatedSections
      };
    });

    // console.log("section.ender_config", formData)
  };

  const handleSectionPositionChange = (e, index) => {
    const newPosition = parseInt(e.target.value);
    setFormData((prev) => ({
      ...prev,
      sections: ReorderList(
        prev.sections,   // prevItems
        index,           // index of moved item
        newPosition,     // new position
        'order'
      ),
    }));
  };

  const handleCompartmentPositionChange = (e, sectionIndex, compartmentIndex) => {
    const newPosition = parseInt(e.target.value);

    setFormData((prev) => {
      const updatedSections = [...prev.sections];
      const section = updatedSections[sectionIndex];

      // Ensure compartments array exists
      if (!section.compartments) {
        section.compartments = [];
      }

      const updatedCompartments = ReorderList(
        section.compartments,   // compartments array
        compartmentIndex,       // index of moved compartment
        newPosition,            // new position
        'order'
      );

      // Update the section with reordered compartments
      updatedSections[sectionIndex] = {
        ...section,
        compartments: updatedCompartments
      };

      return {
        ...prev,
        sections: updatedSections
      };
    });
  };

  const handleFieldPositionChange = (e, sectionIndex, compartmentIndex, fieldIndex) => {
    const newPosition = parseInt(e.target.value);

    setFormData((prev) => {
      const updatedSections = [...prev.sections];
      const section = updatedSections[sectionIndex];

      // Ensure compartments and fields arrays exist
      if (!section.compartments || !section.compartments[compartmentIndex]) {
        return prev; // Safety check
      }

      const compartment = section.compartments[compartmentIndex];

      if (!compartment.fields) {
        compartment.fields = [];
      }

      const currentField = compartment.fields[fieldIndex];
      const currentColumn = currentField.column_position || 1;

      // Only reorder fields within the same column
      const fieldsInSameColumn = compartment.fields.filter(
        (field, idx) => idx !== fieldIndex && (field.column_position || 1) === currentColumn
      );

      // Get available positions for this column (1 to fieldsInSameColumn.length + 1)
      const availablePositions = Array.from(
        { length: fieldsInSameColumn.length + 1 },
        (_, i) => i + 1
      );

      // Ensure newPosition is valid for this column
      const validNewPosition = Math.min(Math.max(newPosition, 1), availablePositions.length);


      // const updatedFields = ReorderList(
      //   compartment.fields,     // fields array
      //   fieldIndex,            // index of moved field
      //   newPosition,           // new position
      //   'order'                // or 'position' depending on your field structure
      // );

      const updatedFields = ReorderList(
        compartment.fields.filter(field => (field.column_position || 1) === currentColumn),
        fieldIndex,
        validNewPosition,
        'order'
      );

      // Update the compartment with reordered fields
      updatedSections[sectionIndex].compartments[compartmentIndex] = {
        ...compartment,
        fields: updatedFields
      };

      return {
        ...prev,
        sections: updatedSections
      };
    });
  };

  return (
    <>
      <button
        title="Add Slip Template"
        className="upload-svg"
        onClick={handleShow}
      >
        <AddwithWhiteCircle /> Slip Template
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="five-sixth-modal"
      >
        <Modal.Header closeButton>
          <div className="flex-row w-full justify-between">
            <Modal.Title>
              Add Slip Template
            </Modal.Title>
            <div className="flex-row">

              <label htmlFor="isDefault" className="font-weight500 font-size-subheading">
                {formData.is_default ? "Is" : "Is Not"} Default
              </label>
              <hr className="field-cont-hr" />
              <div className="checkbox-toggle">
                <input
                  type="checkbox"
                  name="is_default"
                  checked={formData.is_default}
                  onChange={handleChange}
                  id="isDefault"
                />
                <label htmlFor={`isDefault`}></label>
              </div>
              <hr className="field-cont-hr" />
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>

          <div className="parent-div">
            <div className="bdy-div">
              <form className="">
                {/* Basic Information */}


                <div className="form-flex-wrap">
                  {SUPER_ADMIN && (
                    <div className="flex-column">
                      <label className="form-labels font-weight500 font-size-subheading">
                        Sub Company
                      </label>
                      <select
                        name="sub_company"
                        value={formData.sub_company}
                        onChange={handleChange}
                        className="form-input"
                      >
                        <option value="">Select a Company</option>
                        {SUB_COMPANIES?.map((company) => (
                          <option key={company.id} value={company.id}>
                            {company.title}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                  <div className="flex-column ">
                    <label className="form-labels font-weight500 font-size-subheading">
                      Template Name<span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      name="name"
                      placeholder="Template Name"
                      value={formData.name}
                      onChange={handleChange}
                      className={`form-input ${errors.name ? "error" : inputState.name ? "success" : ""}`}
                      required
                    />
                    {errors.name && (
                      <span className="error-message font-size-text ">
                        {errors.name}
                      </span>
                    )}
                  </div>

                  <div className="flex-column">
                    <label className="form-labels font-weight500 font-size-subheading">
                      Description
                    </label>
                    <textarea
                      name="description"
                      placeholder="Description"
                      value={formData.description}
                      onChange={handleChange}
                      className="form-input"
                      rows={3}
                    />
                  </div>

                  <div className="flex-column">
                    <label className="form-labels font-weight500 font-size-subheading">
                      Category<span className="required">*</span>
                    </label>
                    <select
                      name="category_id"
                      value={formData.category_id}
                      onChange={handleChange}
                      className={`form-input ${errors.category_id ? "error" : inputState.category_id ? "success" : ""}`}
                      required
                    >
                      <option value="">Select Category</option>
                      {SLIP_CATEGORIES?.map((category) => (
                        <option key={category.id} value={category.id}>
                          {category.name}
                        </option>
                      ))}
                    </select>
                    {errors.category_id && (
                      <span className="error-message font-size-text ">
                        {errors.category_id}
                      </span>
                    )}
                  </div>

                  <div className="flex-column">
                    <label className="form-labels font-weight500 font-size-subheading">
                      Letter Template<span className="required">*</span>
                      {formData.letter_template && <ViewLetterBuilder
                        buttonDisplay={'Eye-Name'}
                        templateID={formData.letter_template}
                      />}
                    </label>
                    <select
                      name="letter_template"
                      value={formData.letter_template}
                      onChange={handleChange}
                      className={`form-input ${errors.letter_template ? "error" : inputState.letter_template ? "success" : ""}`}
                      required
                    >
                      <option value="">Select Template</option>
                      {LETTER_TEMPLATES?.map((template) => (
                        <option key={template.id} value={template.id}>
                          {template.template_name}
                        </option>
                      ))}
                    </select>
                    {errors.letter_template && (
                      <span className="error-message font-size-text ">
                        {errors.letter_template}
                      </span>
                    )}
                  </div>
                </div>

                <div className="flex-row justify-evenly" style={{ width: "100%" }}>

                  <div className="flex-row">
                    <div className="checkbox-toggle">
                      <input
                        type="checkbox"
                        name="starter_display"
                        checked={formData.starter_display}
                        onChange={handleChange}
                        id="starterDisplay"
                      />
                      <label htmlFor="starterDisplay"></label>
                    </div>
                    <hr className="field-cont-hr" />
                    <label htmlFor="starterDisplay" className="font-weight500 font-size-subheading">
                      {formData.starter_display ? "Show" : "Hide"} Custom Sections
                    </label>
                  </div>


                  <div className="flex-row">
                    <div className="checkbox-toggle">
                      <input
                        type="checkbox"
                        name="body_display"
                        checked={formData.body_display}
                        onChange={handleChange}
                        id="bodyDisplay"
                      />
                      <label htmlFor="bodyDisplay"></label>
                    </div>
                    <hr className="field-cont-hr" />
                    <label htmlFor="bodyDisplay" className="font-weight500 font-size-subheading">
                      {formData.body_display ? "Show" : "Hide"} Custom Body
                    </label>
                  </div>


                  <div className="flex-row">
                    <div className="checkbox-toggle">
                      <input
                        type="checkbox"
                        name="ender_display"
                        checked={formData.ender_display}
                        onChange={handleChange}
                        id="enderDisplay"
                      />
                      <label htmlFor="enderDisplay"></label>
                    </div>
                    <hr className="field-cont-hr" />
                    <label htmlFor="enderDisplay" className="font-weight500 font-size-subheading">
                      {formData.ender_display ? "Show" : "Hide"} Custom Ender
                    </label>
                  </div>
                </div>
                {formData.starter_display && <>
                  <div className="jd-heading-outer heading-bg-color-white">
                    <div className="jd-heading-outer-flex">
                      <h2 className="jd-heading-main font-weight600  font-size-heading">
                        Starter Section Configuration
                      </h2>
                    </div>
                    <div>
                      <div className="jd-heading-bottom-bold"></div>
                      <div className="jd-heading-bottom-light"></div>
                    </div>
                  </div>
                  <ol>
                    {formData.sections?.length > 0 && formData.sections
                      ?.filter(sec => sec.section_type === "starter")
                      .map((section, sectionIndex) => {
                        const originalSectionIndex = formData.sections.findIndex(sec => sec === section);
                        return (
                          <div key={originalSectionIndex}>
                            <li>
                              <div className="flex-row justify-between">
                                Section {sectionIndex + 1}{" "}
                                <button
                                  type="button"
                                  className="required"
                                  onClick={() => removeSection(originalSectionIndex)}
                                >
                                  <CrosswithRedCircle /><span className="ms-1">Remove Section</span>
                                </button>
                              </div>
                              <div className="form-flex-wrap">

                                <div className="flex-column">
                                  <label className="form-label">Section Order</label>
                                  <select
                                    name="order"
                                    value={section.order}
                                    // onChange={(e) => handleSectionPositionChange(e, originalSectionIndex)}
                                    onChange={(e) => handleSectionPositionChange(e, originalSectionIndex)}
                                    className="form-input-date"
                                  >
                                    {Array.from({ length: formData.sections?.filter(sec => sec.section_type === "starter")?.length }, (_, i) => (
                                      <option key={i + 1} value={i + 1}>
                                        {i + 1}
                                      </option>
                                    ))}
                                  </select>
                                </div>

                                <div className="flex-column">
                                  <label className="form-label">Title</label>
                                  <input
                                    type="text"
                                    name="title"
                                    value={section.title}
                                    onChange={(e) => handleSectionChange(e, originalSectionIndex)}
                                    className="form-input"
                                    placeholder="Section title"
                                  />
                                </div>
                              </div>

                              <div className="flex-row">
                                <hr className="line" />
                                <b className="w-52-percent text-center">
                                  {section.title ? `Section "${section.title}"` : `Section ${sectionIndex + 1}`} Compartments
                                </b>
                                <hr className="line" />
                              </div>
                            </li>

                            <ol className="ps-0">
                              {section.compartments?.length > 0 ?
                                (
                                  section.compartments?.map((compartment, compIndex) =>
                                  (
                                    <div key={compIndex} className="compartment-card">
                                      <li>
                                        <div >
                                          <div className="flex-row justify-between">
                                            Compartment {compIndex + 1}{" "}
                                            <button
                                              type="button"
                                              className="required"
                                              onClick={() => removeCompartment(originalSectionIndex, compIndex)}
                                            >
                                              <CrosswithRedCircle /><span className="ms-1">Remove Compartment</span>
                                            </button>
                                          </div>

                                          <div className="form-flex-wrap">
                                            <div className="flex-column">
                                              <label className="form-label">Compartment Order</label>
                                              <select
                                                name="order"
                                                value={compartment.order}
                                                onChange={(e) => handleCompartmentPositionChange(e, originalSectionIndex, compIndex)}
                                                className="form-input-date"
                                              // style={{ width: '60px' }}
                                              >
                                                {Array.from({ length: section.compartments?.length }, (_, i) => (
                                                  <option key={i + 1} value={i + 1}>
                                                    {i + 1}
                                                  </option>
                                                ))}
                                              </select>
                                            </div>
                                            <div className="flex-column">
                                              <label className="form-label">Compartment Layout Type</label>
                                              <select
                                                name="layout_type"
                                                value={compartment.layout_type}
                                                onChange={(e) => handleCompartmentChange(e, originalSectionIndex, compIndex)}
                                                className="form-input-date"
                                              >
                                                {layoutTypes?.map(layout => (
                                                  <option key={layout.value} value={layout.value}>
                                                    {layout.label}
                                                  </option>
                                                ))}
                                              </select>
                                            </div>


                                            {compartment.layout_type === "columns" && (
                                              <div className="flex-row">
                                                <div className="flex-column">
                                                  <label className="form-label">Number of Columns</label>
                                                  <select
                                                    name="columns"
                                                    value={compartment.columns}
                                                    onChange={(e) => handleCompartmentChange(e, originalSectionIndex, compIndex)}
                                                    className="form-input-date"
                                                  >
                                                    <option value=''>Select No. of columns</option>
                                                    {Array.from({ length: 5 }, (_, i) => (
                                                      <option key={i + 2} value={i + 2}>
                                                        {i + 2}
                                                      </option>
                                                    ))}

                                                  </select>
                                                </div>

                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      </li>

                                      <div className="flex-row">
                                        <hr className="line" />
                                        <b className="w-52-percent text-center">
                                          {`Compartment ${compIndex + 1}`} Fields
                                        </b>
                                        <hr className="line" />
                                      </div>

                                      <ol className="ps-0">
                                        {compartment.fields?.length > 0
                                          ?
                                          (
                                            compartment.fields.map((field, fieldIndex) => (
                                              <div key={fieldIndex} className="field-card">
                                                <li>
                                                  <div className="info" >
                                                    <div className="flex-row justify-between">
                                                      Field {fieldIndex + 1}{" "}
                                                      <button
                                                        type="button"
                                                        className="required"
                                                        onClick={() => removeField(originalSectionIndex, compIndex, fieldIndex)}
                                                      >
                                                        <CrosswithRedCircle /><span className="ms-1">Remove Field</span>
                                                      </button>
                                                    </div>
                                                    <div className="form-flex-wrap">

                                                      <div className="flex-column">
                                                        <label className="form-label">Field Order</label>
                                                        <select
                                                          name="order"
                                                          value={field.order}
                                                          onChange={(e) => handleFieldPositionChange(e, originalSectionIndex, compIndex, fieldIndex)}
                                                          className="form-input-date"
                                                        >
                                                          {/* {Array.from({ length: compartment.fields?.length }, (_, i) => (
                                                            <option key={i + 1} value={i + 1}>
                                                              {i + 1}
                                                            </option>
                                                          ))} */}
                                                          {(() => {
                                                            const currentColumn = field.column_position || 1;
                                                            const fieldsInThisColumn = compartment.fields.filter(
                                                              f => (f.column_position || 1) === currentColumn
                                                            );

                                                            return Array.from({ length: fieldsInThisColumn.length }, (_, i) => (
                                                              <option key={i + 1} value={i + 1}>
                                                                {i + 1}
                                                              </option>
                                                            ));
                                                          })()}
                                                        </select>

                                                      </div>

                                                      {compartment.layout_type === "columns" && (
                                                        <div key={fieldIndex} className="flex-column">
                                                          <label className="form-label">Column Number</label>
                                                          <select
                                                            type="number"
                                                            name="column_position"
                                                            value={field.column_position}
                                                            onChange={(e) =>
                                                              handleFieldChange(e, originalSectionIndex, compIndex, fieldIndex)
                                                            }
                                                            className="form-input-date"
                                                          >
                                                            <option value=''>Select Column No.</option>
                                                            {Array.from({ length: compartment.columns }, (_, i) => (
                                                              <option key={i + 1} value={i + 1}>
                                                                {i + 1}
                                                              </option>
                                                            ))}
                                                          </select>
                                                        </div>
                                                      )}

                                                      <div className="flex-column">
                                                        <label className="form-label">Category</label>
                                                        <input
                                                          type="text"
                                                          name="category"
                                                          value={field.category}
                                                          onChange={(e) => handleFieldChange(e, originalSectionIndex, compIndex, fieldIndex)}
                                                          className="form-input"
                                                        />
                                                      </div>

                                                      <div className="flex-column">
                                                        <div className="flex-row justify-between" style={{ gap: '10px' }}>
                                                          <div className="flex-column" style={{ width: '70%' }}>
                                                            <label className="form-label">Label</label>
                                                            <input
                                                              type="text"
                                                              name="label"
                                                              value={field.label}
                                                              onChange={(e) => handleFieldChange(e, originalSectionIndex, compIndex, fieldIndex)}
                                                              className="form-input-date"
                                                              placeholder="Label"
                                                            />
                                                          </div>

                                                          <div className="flex-column" style={{ width: '30%' }}>
                                                            <label className="form-label">Alignment</label>
                                                            <select
                                                              name="label_alignment"
                                                              value={field.label_alignment}
                                                              onChange={(e) => handleFieldChange(e, originalSectionIndex, compIndex, fieldIndex)}
                                                              className="form-input-date"
                                                            >
                                                              {alignmentChoices?.map(al => (
                                                                <option key={al.value} value={al.value}>{al.label}</option>
                                                              ))}
                                                            </select>
                                                          </div>
                                                        </div>
                                                      </div>

                                                      <div className="flex-column">
                                                        <div className="flex-row justify-between" style={{ gap: '10px' }}>
                                                          <div className="flex-column" style={{ width: '70%' }}>
                                                            <label className="form-label">Value</label>
                                                            <input
                                                              type="text"
                                                              name="value_key"
                                                              value={field.value_key}
                                                              onChange={(e) => handleFieldChange(e, originalSectionIndex, compIndex, fieldIndex)}
                                                              className="form-input-date"
                                                              placeholder="Value"
                                                            />
                                                          </div>

                                                          <div className="flex-column" style={{ width: '30%' }}>
                                                            <label className="form-label">Alignment</label>
                                                            <select
                                                              name="value_alignment"
                                                              value={field.value_alignment}
                                                              onChange={(e) => handleFieldChange(e, originalSectionIndex, compIndex, fieldIndex)}
                                                              className="form-input-date"
                                                            >
                                                              {alignmentChoices?.map(al => (
                                                                <option key={al.value} value={al.value}>{al.label}</option>
                                                              ))}
                                                            </select>
                                                          </div>

                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </li>
                                              </div>
                                            ))
                                          )
                                          :
                                          (<p className="text-center mt-2 mb-2">No Fields Selected</p>)

                                        }
                                      </ol>

                                      <div className="flex-row">
                                        <hr className="line" />
                                        <button
                                          type='button'
                                          title="Add Field"
                                          className=" flex-row jd-heading-main font-weight600 gap-2"
                                          onClick={() => addFieldToCompartment(originalSectionIndex, compIndex)}
                                        >
                                          <AddwithBlueCircle /> <span className="w-max-content">{`Add Fields in Compartment ${compIndex + 1}`}</span>
                                        </button>
                                      </div>
                                    </div>
                                  )
                                  )
                                ) : (
                                  <p className="text-center mt-2 mb-2">No Compartment Selected</p>
                                )
                              }
                            </ol>

                            <div className="flex-row">
                              <hr className="line" />
                              <button
                                type='button'
                                title="Add Comparment"
                                className=" flex-row jd-heading-main font-weight600 gap-2"
                                onClick={() => addCompartment(originalSectionIndex)}
                              >
                                <AddwithBlueCircle /> <span className="w-max-content">Add Compartment</span>
                              </button>
                            </div>

                          </div>
                        )
                      })
                    }
                  </ol>

                  <div className="flex-row">
                    <hr className="line" />
                    <button
                      type='button'
                      title="Add Comparment"
                      className=" flex-row jd-heading-main font-weight600 gap-2"
                      onClick={() => addSection()}
                    >
                      <AddwithBlueCircle /> <span className="w-max-content">Add Section</span>
                    </button>
                  </div>
                </>}
                {formData.body_display && <>
                  <div className="jd-heading-outer heading-bg-color-white">
                    <div className="jd-heading-outer-flex">
                      <h2 className="jd-heading-main font-weight600  font-size-heading">
                        Body Section Configuration
                      </h2>
                    </div>
                    <div>
                      <div className="jd-heading-bottom-bold"></div>
                      <div className="jd-heading-bottom-light"></div>
                    </div>
                  </div>
                  {

                    formData.sections.length > 0 && formData.sections
                      ?.filter(sec => sec.section_type === "body")
                      .map((section, sectionIndex) => {
                        const originalSectionIndex = formData.sections.findIndex(sec => sec === section);

                        return (
                          <div key={originalSectionIndex}>

                            <div className="flex-column">
                              <label className="form-label">Title</label>
                              <input
                                type="text"
                                name="title"
                                value={section.title}
                                onChange={(e) => handleSectionChange(e, originalSectionIndex)}
                                className="form-input"
                              />
                            </div>
                          </div>
                        )
                      })}
                </>
                }



                {formData.ender_display && <>
                  <div className="jd-heading-outer heading-bg-color-white">
                    <div className="jd-heading-outer-flex">
                      <h2 className="jd-heading-main font-weight600  font-size-heading">
                        Ender Section Configuration
                      </h2>
                    </div>
                    <div>
                      <div className="jd-heading-bottom-bold"></div>
                      <div className="jd-heading-bottom-light"></div>
                    </div>
                  </div>
                  {
                    formData.sections
                      ?.filter((sec) => sec.section_type === "ender")
                      .map((section, sectionIndex) => {

                        const originalIndex = formData.sections.findIndex(sec => sec === section);

                        return (
                          <div key={originalIndex}>


                            <div className="form-flex-wrap" >
                              <div className="flex-column">
                                <label className="form-labels font-weight500 font-size-subheading">
                                  Title
                                </label>
                                <input
                                  type="text"
                                  name="title"
                                  value={section.title}
                                  onChange={(e) => handleSectionChange(e, originalIndex)}
                                  className="form-input"
                                />
                              </div>

                              <div className="flex-column">
                                <label className="form-labels font-weight500 font-size-subheading">
                                  Ender Type
                                </label>
                                <select
                                  name="ender_type"
                                  value={section.ender_config?.ender_type || ""}
                                  onChange={(e) => handleEnderConfigChange(e, originalIndex)}
                                  className="form-input"
                                >
                                  <option value="signature">Signature</option>
                                  <option value="note">Note</option>
                                  <option value="default">Default Message</option>
                                </select>
                              </div>
                            </div>




                            {section.ender_config?.ender_type === "signature" && (
                              <>
                                <div className="form-flex-wrap ">
                                  <div className="flex-column">
                                    <label className="form-label">Authority Signatory</label>
                                    <select
                                      name="signature_authority"
                                      value={section.ender_config?.signature_authority || ""}
                                      onChange={(e) => handleEnderConfigChange(e, originalIndex)}
                                      className="form-input"
                                    >
                                      {empList
                                        .sort((a, b) => a.emp_code - b.emp_code)
                                        .map((i, index) => (
                                          <option key={i.emp_code} value={i.emp_code}>
                                            {i.name} - {i.emp_code}
                                          </option>
                                        ))}
                                    </select>
                                  </div>

                                  <div className="flex-column">
                                    <label className="form-label">Signature Position</label>
                                    <select
                                      name="authority_name_position"
                                      value={section.ender_config?.authority_name_position || ""}
                                      onChange={(e) => handleEnderConfigChange(e, originalIndex)}
                                      className="form-input-date"
                                    >
                                      <option value="top">Top</option>
                                      <option value="bottom">Bottom</option>
                                    </select>
                                  </div>
                                  <div className="flex-column">
                                    <label className="form-label">Signature Alignment</label>
                                    <select
                                      name="authority_name_alignment"
                                      value={section.ender_config?.authority_name_alignment || ""}
                                      onChange={(e) => handleEnderConfigChange(e, originalIndex)}
                                      className="form-input-date"
                                    >
                                      <option value="left">Left</option>
                                      <option value="center">Center</option>
                                      <option value="right">Right</option>
                                    </select>
                                  </div>
                                </div>
                                <div className="flex-column">
                                  <div className="form-flex-wrap ">

                                    <div className="flex-column">
                                      <div className="flex-row">

                                        <div className="checkbox-toggle">
                                          <input
                                            type="checkbox"
                                            name="show_for_name"
                                            checked={section.ender_config?.show_for_name || false}
                                            onChange={(e) => handleEnderConfigChange(e, originalIndex)}
                                            id="showForName"
                                          />
                                          <label htmlFor="showForName"></label>
                                        </div>
                                        <hr className="field-cont-hr" />
                                        <label
                                          htmlFor="showForName"
                                          className="font-weight500 font-size-subheading"
                                        >
                                          {section.ender_config?.show_for_name
                                            ? "Show"
                                            : "Hide"} Custom For Name
                                        </label>
                                      </div>
                                      {section.ender_config?.show_for_name &&
                                        <div className="flex-row">
                                          <input
                                            id={`for_name_${originalIndex}`}
                                            name="for_name"
                                            type="text"
                                            className="form-input"
                                            value={section.ender_config?.for_name}
                                            placeholder="For Name"
                                            onChange={(e) => handleEnderConfigChange(e, originalIndex)}
                                          />
                                          {/* <label htmlFor={`for_name_${sectionIndex}`}>ss</label> */}
                                        </div>}
                                    </div>
                                    {section.ender_config?.show_for_name &&
                                      (
                                        <>
                                          <div className="flex-column">
                                            <label className="form-label">For Name Position</label>
                                            <select
                                              name="for_name_position"
                                              value={section.ender_config?.for_name_position || ""}
                                              onChange={(e) => handleEnderConfigChange(e, originalIndex)}
                                              className="form-input-date"
                                            >
                                              <option value="top">Top</option>
                                              <option value="bottom">Bottom</option>
                                            </select>
                                          </div>
                                          <div className="flex-column">
                                            <label className="form-label">For Name Alignment</label>
                                            <select
                                              name="for_name_alignment"
                                              value={section.ender_config?.for_name_alignment || ""}
                                              onChange={(e) => handleEnderConfigChange(e, originalIndex)}
                                              className="form-input-date"
                                            >
                                              <option value="left">Left</option>
                                              <option value="center">Center</option>
                                              <option value="right">Right</option>
                                            </select>
                                          </div>
                                        </>
                                      )
                                    }
                                  </div>

                                  <div className="flex-row">
                                    <div className="checkbox-toggle">
                                      <input
                                        type="checkbox"
                                        name="show_assigning_authority"
                                        onChange={(e) => handleEnderConfigChange(e, originalIndex)}
                                        checked={section.ender_config?.show_assigning_authority || false}
                                        id="showAssigningAuthorityName"
                                      // checked={section.ender_config?.show_authority_designation || false}
                                      // onChange={(e) => handleEnderConfigChange(e, sectionIndex)}
                                      // id={`showAuthorityDesignation-${sectionIndex}`}
                                      />
                                      <label htmlFor="showAssigningAuthorityName"></label>
                                    </div>
                                    <hr className="field-cont-hr" />
                                    <label
                                      htmlFor="showAssigningAuthorityName"
                                      className="font-weight500 font-size-subheading"
                                    >
                                      {section.ender_config?.show_assigning_authority ? "Show" : "Hide"} Signatory Authority Details
                                    </label>
                                  </div>
                                </div>


                                {section.ender_config?.show_assigning_authority &&
                                  <>
                                    <div className="flex-row justify-between">
                                      <div className="flex-row">
                                        <div className="checkbox-toggle">
                                          <input
                                            type="checkbox"
                                            name="show_authority_name"
                                            checked={section.ender_config?.show_authority_name || false}
                                            id="showAuthorityName"
                                            onChange={(e) => handleEnderConfigChange(e, originalIndex)}
                                          />
                                          <label htmlFor="showAuthorityName"></label>
                                        </div>
                                        <hr className="field-cont-hr" />
                                        <label
                                          htmlFor="showAuthorityName"
                                          className="font-weight500 font-size-subheading"
                                        >
                                          {section.ender_config?.show_authority_name
                                            ? "Show"
                                            : "Hide"} Authority Name
                                        </label>
                                      </div>
                                      {section.ender_config?.show_authority_name &&
                                        (
                                          <>
                                            <div className="flex-column">
                                              <label className="form-label">Authority Name Position</label>
                                              <select
                                                name="authority_name_position"
                                                value={section.ender_config?.authority_name_position || ""}
                                                onChange={(e) => handleEnderConfigChange(e, originalIndex)}
                                                className="form-input-date"
                                              >
                                                <option value="top">Top</option>
                                                <option value="bottom">Bottom</option>
                                              </select>
                                            </div>
                                            <div className="flex-column">
                                              <label className="form-label">Authority Name Alignment</label>
                                              <select
                                                name="authority_name_alignment"
                                                value={section.ender_config?.authority_name_alignment || ""}
                                                onChange={(e) => handleEnderConfigChange(e, originalIndex)}
                                                className="form-input-date"
                                              >
                                                <option value="left">Left</option>
                                                <option value="center">Center</option>
                                                <option value="right">Right</option>
                                              </select>
                                            </div>
                                          </>
                                        )
                                      }

                                    </div>
                                    <div className="flex-row justify-between">
                                      <div className="flex-row">
                                        <div className="checkbox-toggle">
                                          <input
                                            type="checkbox"
                                            name="show_authority_designation"
                                            checked={section.ender_config?.show_authority_designation || false}
                                            id="showAuthorityDesignation"
                                            onChange={(e) => handleEnderConfigChange(e, originalIndex)}
                                          />
                                          <label htmlFor="showAuthorityDesignation"></label>
                                        </div>
                                        <hr className="field-cont-hr" />
                                        <label
                                          htmlFor="showAuthorityDesignation"
                                          className="font-weight500 font-size-subheading"
                                        >
                                          {section.ender_config?.show_authority_designation
                                            ? "Show"
                                            : "Hide"} Authority Designation
                                        </label>
                                      </div>
                                      {
                                        section.ender_config?.show_authority_designation && (
                                          <>
                                            <div className="flex-column">
                                              <label className="form-label">Authority Designation Position</label>
                                              <select
                                                name="authority_designation_position"
                                                value={section.ender_config?.authority_designation_position || ""}
                                                onChange={(e) => handleEnderConfigChange(e, originalIndex)}
                                                className="form-input-date"
                                              >
                                                <option value="top">Top</option>
                                                <option value="bottom">Bottom</option>
                                              </select>
                                            </div>
                                            <div className="flex-column">
                                              <label className="form-label">Authority Designation Alignment</label>
                                              <select
                                                name="authority_designation_alignment"
                                                value={section.ender_config?.authority_designation_alignment || ""}
                                                onChange={(e) => handleEnderConfigChange(e, originalIndex)}
                                                className="form-input-date"
                                              >
                                                <option value="left">Left</option>
                                                <option value="center">Center</option>
                                                <option value="right">Right</option>
                                              </select>
                                            </div>
                                          </>
                                        )
                                      }
                                    </div>
                                  </>
                                }
                              </>
                            )
                            }

                            {
                              section.ender_config?.ender_type === "note" && (
                                <div className="form-flex-wrap">
                                  <div className="flex-column" style={{ width: "100%" }}>
                                    <label className="form-label">Note Text</label>
                                    <textarea
                                      name="note_text"
                                      value={section.ender_config?.note_text || ""}
                                      onChange={(e) => handleEnderConfigChange(e, originalIndex)}
                                      className="form-input"
                                      rows={4}
                                    />
                                  </div>
                                </div>
                              )
                            }

                            {
                              section.ender_config?.ender_type === "default" && (
                                <div className="form-flex-wrap">
                                  <div className="flex-column" style={{ width: "100%" }}>
                                    <label className="form-label">Default Message :</label>
                                    <b>*This is a software generated slip. No signature required*</b>
                                    {/* <input
                                    type="text"
                                    className="form-input"
                                    readOnly
                                    value={`*This is a software generated slip. No signature required*`}
                                  /> */}
                                  </div>
                                </div>
                              )
                            }
                          </div>
                        )
                      })

                  }
                </>
                }

              </form>

              <div className="button-models">
                <button
                  className="model-button model-button-cancel font-weight500"
                  onClick={handleClose}
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  className="model-button model-button-leave font-weight500 font-size-heading"
                  disabled={loading}
                  onClick={handleSubmit}
                >
                  {loading ? "Creating..." : "Create Slip Template"}
                </button>
              </div>
            </div>
            <p className="error-message font-size-text">
              {isSubmitted && Object.keys(errors).length > 0 && (
                Object.keys(errors).length > 5 ? (
                  <h5 className="text-center">Please fill all mandatory fields!</h5>
                ) : (
                  <h6 className="text-center">
                    {Object.keys(errors)
                      ?.map((field) =>
                        field
                          .replace(/_/g, ' ')
                          .replace(/\b\w/g, (char) => char.toUpperCase())
                      )
                      .join(', ') + ' are required!'}
                  </h6>
                )
              )}
            </p>
          </div>
        </Modal.Body >
      </Modal >

      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
};


const AddSlipBuildDetails = ({
  SUB_COMPANIES,
  SUPER_ADMIN,
  getSlipBuilderData,
  SLIP_CATEGORIES,
  LETTER_TEMPLATES,
  AUTHORITY_USERS,
  empList,

}) => {


  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);



  const initialFormData = {
    name: "",
    description: "",
    is_default: false,
    sub_company: sessionStorage.getItem("company_id"),
    letter_template: "",
    category: "",
    starter_display: false,
    body_display: false,
    ender_display: false,
    sections: [
      {
        section_type: "starter",
        order: 1,
        title: "",
        compartments: [
          {
            layout_type: "full",
            order: 1,
            fields: []
          }
        ]
      },
      {
        section_type: "body",
        order: 2,
        title: "",
        compartments: [
          {
            layout_type: "full",
            columns: 2,
            order: 1,
            fields: []
          }
        ]
      },
      {
        section_type: "ender",
        order: 3,
        title: "",
        compartments: [],

        ender_config: {
          ender_type: "default",
          note_text: "",
          show_for_name: false,
          for_name: "",
          for_name_position: "top",
          for_name_alignment: "center",

          show_assigning_authority: false,
          signature_authority: "",// emp_code
          show_authority_name: false,
          show_authority_designation: false,

          authority_name_position: "bottom",
          authority_name_alignment: "left",

          authority_designation_position: "bottom",
          authority_designation_alignment: "left"
        }
      }
    ]
  };
  const [visibleSections, setVisibleSections] = useState({});
  const [formData, setFormData] = useState(initialFormData);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const toggleFieldsVisibility = (sectionIndex) => {
    setVisibleSections(prev => ({
      ...prev,
      [sectionIndex]: !prev[sectionIndex],
    }));
  };



  const validateForm = () => {
    const newErrors = {};
    const requiredFields = ["name", "category", "letter_template"];

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
      }
    });

    setErrors(newErrors);
    setIsSubmitted(true);
    return Object.keys(newErrors).length === 0;
  };


  const getSortedFields = (fields, compartment) => {
    if (!fields || fields.length === 0) return [];

    if (compartment.layout_type === "columns") {
      return [...fields].sort((a, b) => {
        const colA = a.column_position || 1;
        const colB = b.column_position || 1;
        if (colA !== colB) return colA - colB;
        return parseInt(a.order) - parseInt(b.order);
      });
    } else {
      return [...fields].sort((a, b) => parseInt(a.order) - parseInt(b.order));
    }
  };


  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    const displayToSection = {
      starter_display: "starter",
      body_display: "body",
      ender_display: "ender"
    };


    const getSectionTemplate = (type) => {
      switch (type) {
        case "starter":
          return {
            section_type: "starter",
            order: 1,
            title: "",
            compartments: [
              {
                layout_type: "full",
                order: 1,
                fields: []
              }
            ]
          };
        case "body":
          return {
            section_type: "body",
            order: 2,
            title: "",
            compartments: [
              {
                layout_type: "full",
                columns: 2,
                order: 1,
                fields: []
              }
            ]
          };
        case "ender":
          return {
            section_type: "ender",
            order: 3,
            title: "",
            compartments: [],
            ender_config: {
              ender_type: "default",
              note_text: "",
              show_for_name: false,
              for_name: "",
              for_name_position: "top",
              for_name_alignment: "center",
              show_assigning_authority: false,
              signature_authority: "",
              show_authority_name: false,
              show_authority_designation: false,
              authority_name_position: "bottom",
              authority_name_alignment: "left",
              authority_designation_position: "bottom",
              authority_designation_alignment: "left"
            }
          };
        default:
          return null;
      }
    };


    if (displayToSection[name]) {
      const sectionType = displayToSection[name];

      setFormData((prev) => {
        let newSections = checked
          ? [...prev.sections, getSectionTemplate(sectionType)].filter(
            (s, i, arr) =>
              arr.findIndex((sec) => sec.section_type === s.section_type) === i
          )
          : prev.sections.filter((s) => s.section_type !== sectionType);

        return {
          ...prev,
          [name]: checked,
          sections: newSections.length ? newSections : []
        };
      });
      return;
    }


    setFormData((prev) => {
      if (!prev.starter_display && !prev.body_display && !prev.ender_display) {
        return {
          ...prev,
          sections: [],
          [name]: type === "checkbox" ? checked : value
        };
      }

      return {
        ...prev,
        [name]: type === "checkbox" ? checked : value
      };
    });


    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : ""
    });

    if (value.trim()) {
      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[name];
        return updatedErrors;
      });
    }
  };



  const addSection = () => {
    setFormData(prev => {
      const updatedSections = [...prev.sections];

      updatedSections.push({
        section_type: "starter",
        order: updatedSections.length + 1,
        title: "",
        compartments: [
          {
            order: 1,
            layout_type: "full",
            fields: []
          }
        ],
        // ender_config: null
      });

      return {
        ...prev,
        sections: updatedSections
      };
    });
  };

  const handleSectionChange = (e, sectionIndex) => {
    const { name, value } = e.target;

    setFormData(prev => {
      const updatedSections = [...prev.sections];
      updatedSections[sectionIndex] = {
        ...updatedSections[sectionIndex],
        [name]: value
      };

      return {
        ...prev,
        sections: updatedSections
      };
    });
  };

  const removeSection = (sectionIndex) => {
    setFormData(prev => {
      const updatedSections = [...prev.sections];
      updatedSections.splice(sectionIndex, 1);

      // Reorder section order values
      updatedSections.forEach((section, index) => {
        section.order = index + 1;
      });

      return {
        ...prev,
        sections: updatedSections
      };
    });
  };


  // Add a new compartment to a section
  const addCompartment = (sectionIndex) => {
    setFormData(prev => {
      const updatedSections = [...prev.sections];
      const updatedCompartments = [...updatedSections[sectionIndex].compartments];

      updatedCompartments.push({
        order: updatedCompartments.length + 1,
        layout_type: "full",
        // columns: 2,
        fields: []
      });

      updatedSections[sectionIndex] = {
        ...updatedSections[sectionIndex],
        compartments: updatedCompartments
      };

      return {
        ...prev,
        sections: updatedSections
      };
    });
  };

  // Handle compartment change (layout_type, columns, etc.)
  const handleCompartmentChange = (e, sectionIndex, compartmentIndex) => {
    const { name, value } = e.target;

    setFormData(prev => {
      const updatedSections = [...prev.sections];
      const updatedCompartments = [...updatedSections[sectionIndex].compartments];

      updatedCompartments[compartmentIndex] = {
        ...updatedCompartments[compartmentIndex],
        [name]: name === "columns" ? parseInt(value) : value
      };

      updatedSections[sectionIndex] = {
        ...updatedSections[sectionIndex],
        compartments: updatedCompartments
      };

      return {
        ...prev,
        sections: updatedSections
      };
    });
  };

  // Remove compartment
  const removeCompartment = (sectionIndex, compartmentIndex) => {
    setFormData(prev => {
      const updatedSections = [...prev.sections];
      const updatedCompartments = [...updatedSections[sectionIndex].compartments];

      updatedCompartments.splice(compartmentIndex, 1);

      // Reorder compartments
      updatedCompartments.forEach((comp, index) => {
        comp.order = index + 1;
      });

      updatedSections[sectionIndex] = {
        ...updatedSections[sectionIndex],
        compartments: updatedCompartments
      };

      return {
        ...prev,
        sections: updatedSections
      };
    });
  };


  const addFieldToCompartment = (sectionIndex, compartmentIndex) => {
    setFormData(prev => {
      const updatedSections = [...prev.sections];
      const updatedCompartments = [...updatedSections[sectionIndex].compartments];
      // const updatedFields = [...updatedCompartments[compartmentIndex].fields];
      const compartment = updatedCompartments[compartmentIndex];
      const updatedFields = [...compartment.fields];

      let defaultColumn = 1;
      let defaultOrder = 1;

      if (compartment.layout_type === "columns") {
        // Simply add to column 1 with next available order
        const fieldsInColumn1 = updatedFields.filter(field =>
          (field.column_position || 1) === 1
        ).length;

        defaultColumn = 1;
        defaultOrder = fieldsInColumn1 + 1;
      } else {
        defaultOrder = updatedFields.length + 1;
      }


      // // To Add fields in one column at a time
      // if (compartment.layout_type === "columns") {
      //   // Find the column with the fewest fields for better distribution
      //   const columnCounts = {};
      //   updatedFields.forEach(field => {
      //     const col = field.column_position || 1;
      //     columnCounts[col] = (columnCounts[col] || 0) + 1;
      //   });

      //   console.log("columnCounts", columnCounts)

      //   // Use column 1 by default, or find column with least fields
      //   defaultColumn = 1;
      //   let minCount = columnCounts[1] || 0;
      //   for (let col = 2; col <= (compartment.columns || 2); col++) {
      //     const count = columnCounts[col] || 0;
      //     if (count < minCount) {
      //       minCount = count;
      //       defaultColumn = col;
      //     }
      //   }

      //   defaultOrder = (columnCounts[defaultColumn] || 0) + 1;
      // } else {
      //   defaultOrder = updatedFields.length + 1;
      // }

      updatedFields.push({
        label: "",
        label_alignment: "left",
        category: "",
        value_key: "",
        value_alignment: "left",
        order: defaultOrder,
        column_position: compartment.layout_type === "columns" ? defaultColumn : undefined
      });

      // updatedFields.push({
      //   label: "",
      //   label_alignment: "left",
      //   category: "",
      //   value_key: "",
      //   value_alignment: "left",
      //   order: updatedFields.length + 1
      // });

      updatedCompartments[compartmentIndex] = {
        ...updatedCompartments[compartmentIndex],
        fields: updatedFields
      };

      updatedSections[sectionIndex] = {
        ...updatedSections[sectionIndex],
        compartments: updatedCompartments
      };

      return {
        ...prev,
        sections: updatedSections
      };
    });
  };

  const handleFieldChange = (e, sectionIndex, compartmentIndex, fieldIndex) => {
    const { name, value } = e.target;

    setFormData(prev => {
      const updatedSections = [...prev.sections];
      const updatedCompartments = [...updatedSections[sectionIndex].compartments];
      const updatedFields = [...updatedCompartments[compartmentIndex].fields];
      const compartment = updatedCompartments[compartmentIndex];


      if (name === "column_position" && compartment.layout_type === "columns") {
        const newColumn = parseInt(value);

        // Count how many fields are already in the new column
        const fieldsInNewColumn = updatedFields.filter(
          (field, idx) => idx !== fieldIndex && (field.column_position || 1) === newColumn
        ).length;

        updatedFields[fieldIndex] = {
          ...updatedFields[fieldIndex],
          [name]: newColumn,
          order: fieldsInNewColumn + 1 // Set to next available position in new column
        };
      } else {
        // For other field changes
        updatedFields[fieldIndex] = {
          ...updatedFields[fieldIndex],
          [name]: value
        };
      }


      // if (name === "column_position" && compartment.layout_type === "columns") {
      //   const newColumn = parseInt(value);
      //   const currentColumn = updatedFields[fieldIndex].column_position;

      //   // If moving to a different column, set order to last position in new column
      //   if (newColumn !== currentColumn) {
      //     // Count how many fields are already in the new column
      //     const fieldsInNewColumn = updatedFields.filter(
      //       (field, idx) => idx !== fieldIndex && field.column_position === newColumn
      //     ).length;

      //     updatedFields[fieldIndex] = {
      //       ...updatedFields[fieldIndex],
      //       [name]: newColumn,
      //       order: fieldsInNewColumn + 1 // Set to next available position in new column
      //     };
      //   } else {
      //     // Same column, just update the value
      //     updatedFields[fieldIndex] = {
      //       ...updatedFields[fieldIndex],
      //       [name]: newColumn
      //     };
      //   }
      // } else {
      //   // For other field changes
      //   updatedFields[fieldIndex] = {
      //     ...updatedFields[fieldIndex],
      //     [name]: value
      //   };
      // }

      // updatedFields[fieldIndex] = {
      //   ...updatedFields[fieldIndex],
      //   [name]: value
      // };

      updatedCompartments[compartmentIndex] = {
        ...updatedCompartments[compartmentIndex],
        fields: updatedFields
      };

      updatedSections[sectionIndex] = {
        ...updatedSections[sectionIndex],
        compartments: updatedCompartments
      };

      return {
        ...prev,
        sections: updatedSections
      };
    });
  };

  const removeField = (sectionIndex, compartmentIndex, fieldIndex) => {
    setFormData(prev => {
      const updatedSections = [...prev.sections];
      const updatedCompartments = [...updatedSections[sectionIndex].compartments];
      const compartment = updatedCompartments[compartmentIndex];
      const updatedFields = [...compartment.fields];

      const fieldToRemove = updatedFields[fieldIndex];
      const columnOfRemovedField = fieldToRemove.column_position || 1;

      updatedFields.splice(fieldIndex, 1);

      // // Update positions
      // updatedFields.forEach((field, index) => {
      //   field.order = index + 1;
      // });

      // Reorder only the fields in the same column as the removed field
      const fieldsInSameColumn = updatedFields.filter(
        field => (field.column_position || 1) === columnOfRemovedField
      );

      if (fieldsInSameColumn.length > 0) {
        // Create a temporary array to use ReorderList for normalization
        const normalizedFields = fieldsInSameColumn.map((field, index) => ({
          ...field,
          order: (index + 1).toString()
        }));

        // Update the original fields with normalized orders
        normalizedFields.forEach((normalizedField, index) => {
          const originalIndex = updatedFields.findIndex(
            f => f === fieldsInSameColumn[index]
          );
          if (originalIndex !== -1) {
            updatedFields[originalIndex].order = normalizedField.order;
          }
        });
      }

      updatedCompartments[compartmentIndex] = {
        ...updatedCompartments[compartmentIndex],
        fields: updatedFields
      };

      updatedSections[sectionIndex] = {
        ...updatedSections[sectionIndex],
        compartments: updatedCompartments
      };

      return {
        ...prev,
        sections: updatedSections
      };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoading(true);

      const loadingToastId = toast.loading("Creating slip template...");
      const { starter_display, body_display, ender_display, ...payload } = formData

      try {
        let res = await axios.post(
          `${BASE_URL}/wfm/slip-builder/`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (res.status === 200 || res.status === 201) {
          await getSlipBuilderData();
          setShow(false);
          setFormData(initialFormData);
          toast.success("Slip template created successfully!");
        }
      } catch (err) {
        handleErrorToast(err, loadingToastId);
      } finally {
        setLoading(false);
        toast.dismiss(loadingToastId);
      }
    }
  };

  const sectionTypes = [
    { value: "starter", label: "Starter Section" },
    { value: "body", label: "Body Section" },
    { value: "ender", label: "Ender Section" }
  ];

  const layoutTypes = [
    { value: "full", label: "Full Width" },
    { value: "columns", label: "Multi Columns" }
  ];

  const alignmentChoices = [
    { value: "left", label: "Left" },
    { value: "center", label: "Center" },
    { value: "right", label: "Right" }
  ];

  const enderTypes = [
    { value: "signature", label: "Signature" },
    { value: "note", label: "Note" },
    { value: "default", label: "Default Message" }
  ];


  const handleEnderConfigChange = (e, sectionIndex) => {
    const { name, type, checked, value } = e.target;

    setFormData((prev) => {
      const updatedSections = prev.sections.map((section, idx) => {
        if (idx !== sectionIndex) return section;
        console.log('idx !== sectionIndex', idx !== sectionIndex)
        console.log('name', name)
        console.log('value', value)
        console.log('section.ender_config', section.ender_config)
        return {
          ...section,
          ender_config: {
            ...section.ender_config,
            [name]: type === "checkbox" ? checked : value
          }
        };
      });

      return {
        ...prev,
        sections: updatedSections
      };
    });

  };

  const handleSectionPositionChange = (e, index) => {
    const newPosition = parseInt(e.target.value);
    setFormData((prev) => ({
      ...prev,
      sections: ReorderList(
        prev.sections,   // prevItems
        index,           // index of moved item
        newPosition,     // new position
        'order'
      ),
    }));
  };

  const handleCompartmentPositionChange = (e, sectionIndex, compartmentIndex) => {
    const newPosition = parseInt(e.target.value);

    setFormData((prev) => {
      const updatedSections = [...prev.sections];
      const section = updatedSections[sectionIndex];

      // Ensure compartments array exists
      if (!section.compartments) {
        section.compartments = [];
      }

      const updatedCompartments = ReorderList(
        section.compartments,   // compartments array
        compartmentIndex,       // index of moved compartment
        newPosition,            // new position
        'order'
      );

      // Update the section with reordered compartments
      updatedSections[sectionIndex] = {
        ...section,
        compartments: updatedCompartments
      };

      return {
        ...prev,
        sections: updatedSections
      };
    });
  };

  const handleFieldPositionChange = (e, sectionIndex, compartmentIndex, fieldIndex) => {
    const newPosition = parseInt(e.target.value);

    setFormData((prev) => {
      const updatedSections = [...prev.sections];
      const section = updatedSections[sectionIndex];

      if (!section.compartments || !section.compartments[compartmentIndex]) {
        return prev;
      }

      const compartment = section.compartments[compartmentIndex];

      if (!compartment.fields) {
        compartment.fields = [];
      }

      const currentField = compartment.fields[fieldIndex];
      const currentColumn = currentField.column_position || 1;

      // If it's a column layout, only reorder within the same column
      if (compartment.layout_type === "columns") {
        // Get all fields in the current column
        const fieldsInCurrentColumn = compartment.fields.filter(
          field => (field.column_position || 1) === currentColumn
        );

        // Find the index of the current field within the column-specific array
        const columnFieldIndex = fieldsInCurrentColumn.findIndex(
          field => field === currentField
        );

        if (columnFieldIndex === -1) return prev; // Safety check

        // Reorder only within the same column using ReorderList
        const reorderedColumnFields = ReorderList(
          fieldsInCurrentColumn,
          columnFieldIndex,
          newPosition,
          'order'
        );

        // Combine with fields from other columns
        const fieldsFromOtherColumns = compartment.fields.filter(
          field => (field.column_position || 1) !== currentColumn
        );

        const updatedFields = [...fieldsFromOtherColumns, ...reorderedColumnFields];

        // Sort all fields by column first, then by order within each column
        updatedFields.sort((a, b) => {
          const colA = a.column_position || 1;
          const colB = b.column_position || 1;
          if (colA !== colB) {
            return colA - colB;
          }
          return parseInt(a.order) - parseInt(b.order);
        });

        // Update the compartment with reordered fields
        updatedSections[sectionIndex].compartments[compartmentIndex] = {
          ...compartment,
          fields: updatedFields
        };
      } else {
        // For full-width layout, use the original ReorderList logic
        const updatedFields = ReorderList(
          compartment.fields,
          fieldIndex,
          newPosition,
          'order'
        );

        updatedSections[sectionIndex].compartments[compartmentIndex] = {
          ...compartment,
          fields: updatedFields
        };
      }

      return {
        ...prev,
        sections: updatedSections
      };
    });
  };

  return (
    <>
      <button
        title="Add Slip Template"
        className="upload-svg"
        onClick={handleShow}
      >
        <AddwithWhiteCircle /> Slip Template
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="five-sixth-modal"
      >
        <Modal.Header closeButton>
          <div className="flex-row w-full justify-between">
            <Modal.Title>
              Add Slip Template
            </Modal.Title>
            <div className="flex-row">

              <label htmlFor="isDefault" className="font-weight500 font-size-subheading">
                {formData.is_default ? "Is" : "Is Not"} Default
              </label>
              <hr className="field-cont-hr" />
              <div className="checkbox-toggle">
                <input
                  type="checkbox"
                  name="is_default"
                  checked={formData.is_default}
                  onChange={handleChange}
                  id="isDefault"
                />
                <label htmlFor={`isDefault`}></label>
              </div>
              <hr className="field-cont-hr" />
            </div>
          </div>
        </Modal.Header>
        <Modal.Body className="bg-gray-shade-color">

          <div className="parent-div">
            <div className="bg-gray-shade-color">
              <form className="bg-gray-shade-color">
                <div className="bdy-div slip-builder-card">
                  <div className="form-flex-wrap">
                    {SUPER_ADMIN && (
                      <div className="flex-column emp_data_timeline_filters" >
                        <label className="form-labels font-weight500 font-size-subheading">
                          Sub Company
                        </label>
                        <select
                          name="sub_company"
                          value={formData.sub_company}
                          onChange={handleChange}
                          className="form-input"
                        >
                          <option value="">Select a Company</option>
                          {SUB_COMPANIES?.map((company) => (
                            <option key={company.id} value={company.id}>
                              {company.title}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}

                    <div className="flex-column emp_data_timeline_filters" >
                      <label className="form-labels font-weight500 font-size-subheading">
                        Template Name<span className="required">*</span>
                      </label>
                      <input
                        type="text"
                        name="name"
                        placeholder="Template Name"
                        value={formData.name}
                        onChange={handleChange}
                        className={`form-input ${errors.name ? "error" : inputState.name ? "success" : ""}`}
                        required
                      />
                      {errors.name && (
                        <span className="error-message font-size-text ">
                          {errors.name}
                        </span>
                      )}
                    </div>
                    <div className="flex-column emp_data_timeline_filters">
                      <label className="form-labels font-weight500 font-size-subheading">
                        Category<span className="required">*</span>
                      </label>
                      <select
                        name="category"
                        value={formData.category}
                        onChange={handleChange}
                        className={`form-input ${errors.category ? "error" : inputState.category ? "success" : ""}`}
                        required
                      >
                        <option value="">Select Category</option>
                        {SLIP_CATEGORIES?.map((category) => (
                          <option key={category.id} value={category.id}>
                            {category.name}
                          </option>
                        ))}
                      </select>
                      {errors.category && (
                        <span className="error-message font-size-text ">
                          {errors.category}
                        </span>
                      )}
                    </div>


                    <div className="flex-column emp_data_timeline_filters" >
                      <label className="form-labels font-weight500 font-size-subheading">
                        Letter Template<span className="required">*</span>
                        {formData.letter_template && <ViewLetterBuilder
                          buttonDisplay={'Eye-Name'}
                          templateID={formData.letter_template}
                        />}
                      </label>
                      <select
                        name="letter_template"
                        value={formData.letter_template}
                        onChange={handleChange}
                        className={`form-input ${errors.letter_template ? "error" : inputState.letter_template ? "success" : ""}`}
                        required
                      >
                        <option value="">Select Template</option>
                        {LETTER_TEMPLATES?.map((template) => (
                          <option key={template.id} value={template.id}>
                            {template.template_name}
                          </option>
                        ))}
                      </select>
                      {errors.letter_template && (
                        <span className="error-message font-size-text ">
                          {errors.letter_template}
                        </span>
                      )}
                    </div>

                    <div className="flex-column emp_data_timeline_filters">
                      <label className="form-labels font-weight500 font-size-subheading">
                        Description
                      </label>
                      <textarea
                        name="description"
                        placeholder="Description"
                        value={formData.description}
                        onChange={handleChange}
                        className="form-input"
                        rows={3}
                      />
                    </div>
                  </div>

                  <div className="slip-builder-toggle-row">
                    <div className="slip-builder-toggle-card flex-row">
                      <div className="checkbox-toggle">
                        <input
                          type="checkbox"
                          name="starter_display"
                          checked={formData.starter_display}
                          onChange={handleChange}
                          id="starterDisplay"
                        />
                        <label htmlFor="starterDisplay"></label>
                      </div>
                      <hr className="field-cont-hr" />
                      <label htmlFor="starterDisplay" className="font-weight500 font-size-subheading">
                        {formData.starter_display ? "Show" : "Hide"} Custom Sections
                      </label>
                    </div>

                    {/* <div className="slip-builder-toggle-card flex-row">
                      <div className="checkbox-toggle">
                        <input
                          type="checkbox"
                          name="body_display"
                          checked={formData.body_display}
                          onChange={handleChange}
                          id="bodyDisplay"
                        />
                        <label htmlFor="bodyDisplay"></label>
                      </div>
                      <hr className="field-cont-hr" />
                      <label htmlFor="bodyDisplay" className="font-weight500 font-size-subheading">
                        {formData.body_display ? "Show" : "Hide"} Custom Body
                      </label>
                    </div>

                    <div className="slip-builder-toggle-card flex-row">
                      <div className="checkbox-toggle">
                        <input
                          type="checkbox"
                          name="ender_display"
                          checked={formData.ender_display}
                          onChange={handleChange}
                          id="enderDisplay"
                        />
                        <label htmlFor="enderDisplay"></label>
                      </div>
                      <hr className="field-cont-hr" />
                      <label htmlFor="enderDisplay" className="font-weight500 font-size-subheading">
                        {formData.ender_display ? "Show" : "Hide"} Custom Ender
                      </label>
                    </div> */}
                  </div>

                </div>
                {(formData.starter_display || formData.body_display || formData.ender_display) && (
                  <div className="jd-heading-outer slip-builder-section-heading" style={{ paddingLeft: '24px', marginTop: '2px' }}>
                    <div className="jd-heading-outer-flex">
                      <h2 className="jd-heading-main font-weight600 font-size-heading">
                        Sections Configuration
                      </h2>
                    </div>
                  </div>
                )}

                {/* ===== STARTER SECTION ===== */}

                {formData.starter_display && (
                  <div className="slip-builder-card">
                    <div className="modern-card" style={{ marginBottom: '28px' }}>
                      <div className="section-header header" style={{ alignItems: 'center', paddingLeft: '24px', paddingRight: '24px' }}>
                        <h3 style={{ margin: 0, fontSize: '1.2rem', fontWeight: 600, color: '#0f172a' }}>Starter Sections</h3>
                        <button type="button" className="btn-modern-primary" onClick={() => addSection()} style={{ fontSize: '0.8rem', padding: '0.4rem 1rem', border: '0.5px solid #cbd5e1', borderRadius: '10px', }}>
                          <AddwithBlueCircle /> Add Section
                        </button>
                      </div>
                      <div style={{ padding: '1.5rem' }}>
                        {formData.sections?.filter(sec => sec.section_type === "starter")?.length === 0 && (
                          <div style={{ textAlign: 'center', padding: '2rem', background: '#fafcff', borderRadius: '20px', border: '1px dashed #cbd5e1', color: '#475569' }}>
                            No starter sections yet. Click "Add Section" to begin.
                          </div>
                        )}
                        {formData.sections?.filter(sec => sec.section_type === "starter").map((section, sectionIndex) => {
                          const originalSectionIndex = formData.sections.findIndex(sec => sec === section);
                          return (
                            <div key={originalSectionIndex} className="compartment-card" style={{ marginBottom: '1.5rem', overflow: 'hidden' }}>
                              <div style={{ background: '#f1f1f1', padding: '0.75rem 1.25rem', borderBottom: '1px solid #eef2f6', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderRadius: '10px' }}>
                                <div style={{ fontWeight: 600, }}>Section {sectionIndex + 1}</div>
                                <button type="button" className="btn-icon-remove" onClick={() => removeSection(originalSectionIndex)}>
                                  <DeleteDustbin />
                                </button>
                              </div>
                              <div style={{ padding: '1.25rem' }}>
                                <div className="items" style={{ marginBottom: '1.25rem' }}>
                                  <div className="flex-column">
                                    <label className="form-label">Section Order</label>
                                    <select name="order" value={section.order} onChange={(e) => handleSectionPositionChange(e, originalSectionIndex)} className="form-input-date" style={{ border: '0.2px solid #e3e3e3', marginTop: '-1px' }}>
                                      {Array.from({ length: formData.sections?.filter(sec => sec.section_type === "starter")?.length }, (_, i) => (
                                        <option key={i + 1} value={i + 1}>{i + 1}</option>
                                      ))}
                                    </select>
                                  </div>
                                  <div className="flex-column">
                                    <label className="form-label">Title</label>
                                    <input
                                      type="text"
                                      name="title"
                                      value={section.title}
                                      onChange={(e) => handleSectionChange(e, originalSectionIndex)}
                                      className="form-input"
                                      style={{ margin: "-1px 0px 10px 0px" }}
                                      placeholder="Section title"
                                    />
                                  </div>
                                </div>

                                {/* COMPARTMENTS */}
                                <div style={{ marginTop: '1rem' }}>
                                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                                    <h3 style={{ margin: 0, fontSize: '1.2rem', fontWeight: 600, color: '#0f172a' }}>Compartments</h3>

                                    <button type="button" className="btn-modern-primary" onClick={() => addCompartment(originalSectionIndex)} style={{ fontSize: '0.8rem', padding: '0.4rem 1rem', border: '0.5px solid #cbd5e1', borderRadius: '10px', }}>
                                      <AddwithBlueCircle />  Add Compartment
                                    </button>
                                  </div>
                                  {section.compartments?.length === 0 && (
                                    <div style={{ background: '#f8fafc', padding: '1rem', borderRadius: '12px', textAlign: 'center', color: '#64748b', fontSize: '0.85rem' }}>No compartments. Add one to organize fields.</div>
                                  )}
                                  {section.compartments?.map((compartment, compIndex) => (
                                    <div key={compIndex} className="field-card" style={{ marginBottom: '1rem', padding: '1rem' }}>
                                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem' }}>
                                        <span style={{ fontSize: '0.9rem', fontWeight: 500, background: '#f1f5f9', padding: '2px 8px', borderRadius: '20px' }}>Compartment {compIndex + 1}</span>
                                        <button type="button" className="btn-icon-remove" onClick={() => removeCompartment(originalSectionIndex, compIndex)}>
                                          <DeleteDustbin />
                                        </button>
                                      </div>
                                      <div className="form-flex-wrap" style={{ marginBottom: '1rem' }}>
                                        <div className="flex-column">
                                          <label className="form-label">Compartment Order</label>
                                          <select
                                            name="order"
                                            value={compartment.order}
                                            onChange={(e) => handleCompartmentPositionChange(e, originalSectionIndex, compIndex)}
                                            className="form-input-date"
                                            style={{ border: '0.2px solid #e3e3e3' }}
                                          >
                                            {Array.from({ length: section.compartments?.length }, (_, i) => (<option key={i + 1} value={i + 1}>{i + 1}</option>))}
                                          </select>
                                        </div>
                                        <div className="flex-column">
                                          <label className="form-label">Compartment Layout Type</label>
                                          <select
                                            name="layout_type"
                                            value={compartment.layout_type}
                                            onChange={(e) => handleCompartmentChange(e, originalSectionIndex, compIndex)}
                                            className="form-input-date"
                                            style={{ border: '0.2px solid #e3e3e3' }}
                                          >
                                            {layoutTypes?.map(layout => (<option key={layout.value} value={layout.value}>{layout.label}</option>))}
                                          </select>
                                        </div>
                                        {compartment.layout_type === "columns" && (
                                          <div className="flex-row">
                                            <div className="flex-column">
                                              <label className="form-label">Number of Columns</label>
                                              <select
                                                name="columns"
                                                value={compartment.columns}
                                                onChange={(e) => handleCompartmentChange(e, originalSectionIndex, compIndex)}
                                                className="form-input-date"
                                                style={{ border: '0.2px solid #e3e3e3' }}
                                              >
                                                <option value=''>Select No. of columns</option>
                                                {[2, 3].map(num => (<option key={num} value={num}>{num}</option>))}
                                              </select>
                                            </div>
                                          </div>
                                        )}
                                      </div>

                                      {/* FIELDS */}
                                      <div style={{ marginTop: '0.75rem' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem' }}>
                                          <h3 style={{ margin: 0, fontSize: '1.2rem', fontWeight: 600, color: '#0f172a' }}>Fields</h3>

                                          <button type="button" className="btn-modern-primary" onClick={() => addFieldToCompartment(originalSectionIndex, compIndex)} style={{ fontSize: '0.8rem', padding: '0.4rem 1rem', border: '0.5px solid #cbd5e1', borderRadius: '10px', }}>
                                            <AddwithBlueCircle />  Add Field
                                          </button>
                                        </div>
                                        {compartment.fields?.length === 0 && <div style={{ background: '#f8fafc', borderRadius: '10px', padding: '0.8rem', textAlign: 'center', fontSize: '0.8rem' }}>No fields added.</div>}
                                        {getSortedFields(compartment.fields, compartment).map((field, fieldIndex) => {
                                          const originalFieldIndex = compartment.fields.findIndex(f => f === field);
                                          return (
                                            <div key={fieldIndex} style={{ background: '#ffffff', border: '1px solid #eef2f6', borderRadius: '12px', padding: '0.8rem', marginBottom: '0.65rem', boxShadow: 'rgba(15, 39, 65, 0.08) 0px 1px 19px' }}>
                                              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.65rem' }}>
                                                <span style={{ fontSize: '0.9rem', fontWeight: 500, background: '#f1f5f9', padding: '2px 8px', borderRadius: '20px' }}>Field {fieldIndex + 1}</span>
                                                <button type="button" className="btn-icon-remove" onClick={() => removeField(originalSectionIndex, compIndex, originalFieldIndex)} style={{ fontSize: '0.7rem' }}>
                                                  <DeleteDustbin />
                                                </button>
                                              </div>
                                              <div className="form-flex-wrap" >
                                                <div className="flex-column">
                                                  <label className="form-label">Field Order</label>
                                                  <select
                                                    name="order"
                                                    value={field.order}
                                                    onChange={(e) => handleFieldPositionChange(e, originalSectionIndex, compIndex, originalFieldIndex)}
                                                    className="form-input-date"
                                                    style={{ border: '0.2px solid #e3e3e3', marginTop: '-1px' }}
                                                  >
                                                    {(() => {
                                                      const currentColumn = field.column_position || 1;
                                                      const fieldsInThisColumn = compartment.fields.filter(f => (f.column_position || 1) === currentColumn);
                                                      return Array.from({ length: fieldsInThisColumn.length }, (_, i) => (<option key={i + 1} value={i + 1}>{i + 1}</option>));
                                                    })()}
                                                  </select>
                                                </div>
                                                {compartment.layout_type === "columns" && (
                                                  <div key={originalFieldIndex} className="flex-column">
                                                    <label className="form-label">Column Number</label>
                                                    <select
                                                      type="number"
                                                      name="column_position"
                                                      value={field.column_position}
                                                      onChange={(e) =>
                                                        handleFieldChange(e, originalSectionIndex, compIndex, originalFieldIndex)
                                                      }
                                                      className="form-input-date"
                                                      style={{ border: '0.2px solid #e3e3e3' }}
                                                    >
                                                      <option value="">Select Column No.</option>
                                                      {Array.from({ length: compartment.columns }, (_, i) => (<option key={i + 1} value={i + 1}>{i + 1}</option>))}
                                                    </select>
                                                  </div>
                                                )}
                                                <div className="flex-column">
                                                  <label className="form-label">Category</label>
                                                  <input
                                                    type="text"
                                                    name="category"
                                                    value={field.category}
                                                    onChange={(e) => handleFieldChange(e, originalSectionIndex, compIndex, originalFieldIndex)}
                                                    className="form-input"
                                                  />
                                                </div>
                                                <div className="flex-column">
                                                  <div className="flex-row justify-between" style={{ gap: '10px' }}>
                                                    <div className="flex-column" style={{ width: '70%' }}>
                                                      <label className="form-label">Label</label>
                                                      <input
                                                        type="text"
                                                        name="label"
                                                        value={field.label}
                                                        onChange={(e) => handleFieldChange(e, originalSectionIndex, compIndex, originalFieldIndex)}
                                                        className="form-input-date"
                                                        placeholder="Label"
                                                        style={{ border: '0.2px solid #e3e3e3' }}
                                                      />
                                                    </div>
                                                    <div className="flex-column" style={{ width: '30%' }}>
                                                      <label className="form-label">Alignment</label>
                                                      <select
                                                        name="label_alignment"
                                                        value={field.label_alignment}
                                                        onChange={(e) => handleFieldChange(e, originalSectionIndex, compIndex, originalFieldIndex)}
                                                        className="form-input-date"
                                                        style={{ border: '0.2px solid #e3e3e3' }}
                                                      >
                                                        {alignmentChoices?.map(al => (<option key={al.value} value={al.value}>{al.label}</option>))}
                                                      </select>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div className="flex-column">
                                                  <div className="flex-row justify-between" style={{ gap: '10px' }}>
                                                    <div className="flex-column" style={{ width: '70%' }}>
                                                      <label className="form-label">Value</label>
                                                      <input
                                                        type="text"
                                                        name="value_key"
                                                        value={field.value_key}
                                                        onChange={(e) => handleFieldChange(e, originalSectionIndex, compIndex, originalFieldIndex)}
                                                        className="form-input-date"
                                                        placeholder="Value"
                                                        style={{ border: '0.2px solid #e3e3e3' }}
                                                      />
                                                    </div>
                                                    <div className="flex-column" style={{ width: '30%' }}>
                                                      <label className="form-label">Alignment</label>
                                                      <select
                                                        name="value_alignment"
                                                        value={field.value_alignment}
                                                        onChange={(e) => handleFieldChange(e, originalSectionIndex, compIndex, originalFieldIndex)}
                                                        className="form-input-date"
                                                        style={{ border: '0.2px solid #e3e3e3' }}
                                                      >
                                                        {alignmentChoices?.map(al => (
                                                          <option key={al.value} value={al.value}>{al.label}</option>
                                                        ))}
                                                      </select>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          );
                                        })}
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                )}

                {/* ===== BODY SECTION ===== */}
                {/* {formData.body_display && (
                  <div className="slip-builder-card">
                    <div className="modern-card" style={{ marginBottom: '28px' }}>
                      <div className="section-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingLeft: '24px', paddingRight: '24px' }}>
                        <h3 style={{ margin: 0, fontSize: '1.2rem', fontWeight: 600, color: '#0f172a' }}>Body Section</h3>
                      </div>
                      <div style={{ padding: '1.5rem' }}>
                        {formData.sections.filter(sec => sec.section_type === "body").map((section, sectionIndex) => {
                          const originalSectionIndex = formData.sections.findIndex(sec => sec === section);
                          return (
                            <div key={originalSectionIndex} className="flex-column">
                              <label className="form-label">Body Title</label>
                              <input type="text" name="title" value={section.title} onChange={(e) => handleSectionChange(e, originalSectionIndex)} className="form-input" placeholder="Main content title" />
                            </div>
                          );
                        })}
                        {formData.sections.filter(sec => sec.section_type === "body").length === 0 && (
                          <div style={{ textAlign: 'center', color: '#94a3b8', padding: '1rem' }}>No body section configured. It will appear when you add data.</div>
                        )}
                      </div>
                    </div>
                  </div>
                )} */}

                {/* ===== ENDER SECTION ===== */}
                {/* {formData.ender_display && (
                  <div className="slip-builder-card">
                    <div className="modern-card" style={{ marginBottom: '28px' }}>
                      <div className="section-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingLeft: '24px', paddingRight: '24px' }}>
                        <h3 style={{ margin: 0, fontSize: '1.2rem', fontWeight: 600, color: '#0f172a' }}>Ender Configuration</h3>
                      </div>
                      <div style={{ padding: '1.5rem' }}>
                        {formData.sections.filter(sec => sec.section_type === "ender").map((section, idx) => {
                          const originalIndex = formData.sections.findIndex(sec => sec === section);
                          return (
                            <div key={originalIndex} className="flex-column">
                              <div className="items" style={{ marginBottom: '1.25rem' }}>
                                <div className="flex-column">
                                  <label className="form-label">Ender Title</label>
                                  <input type="text" name="title" value={section.title} onChange={(e) => handleSectionChange(e, originalIndex)} className="form-input" style={{ border: '0.2px solid #e3e3e3', }} />
                                </div>
                                <div className="flex-column">
                                  <label className="form-label">Ender Type</label>
                                  <select name="ender_type" value={section.ender_config?.ender_type || ""} onChange={(e) => handleEnderConfigChange(e, originalIndex)} className="form-input-date" style={{ border: '0.2px solid #e3e3e3' }}>
                                    <option value="signature">Signature</option>
                                    <option value="note">Note</option>
                                    <option value="default">Default Message</option>
                                  </select>
                                </div>
                              </div>

                              {section.ender_config?.ender_type === "signature" && (
                                <div style={{ background: '#fefce8', borderRadius: '14px', padding: '1rem', marginTop: '0.5rem' }}>
                                  <div className="form-flex-wrap" style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
                                    <div style={{ flex: '1 1 240px' }}>
                                      <label className="form-label-modern">Authority Signatory</label>
                                      <select name="signature_authority" value={section.ender_config?.signature_authority || ""} onChange={(e) => handleEnderConfigChange(e, originalIndex)} className="form-input-modern">
                                        {empList.sort((a, b) => a.emp_code - b.emp_code).map(i => (<option key={i.emp_code} value={i.emp_code}>{i.name} - {i.emp_code}</option>))}
                                      </select>
                                    </div>
                                    <div><label className="form-label-modern">Pos</label><select name="authority_name_position" value={section.ender_config?.authority_name_position || ""} onChange={(e) => handleEnderConfigChange(e, originalIndex)} className="form-input-modern"><option value="top">Top</option><option value="bottom">Bottom</option></select></div>
                                    <div><label className="form-label-modern">Align</label><select name="authority_name_alignment" value={section.ender_config?.authority_name_alignment || ""} onChange={(e) => handleEnderConfigChange(e, originalIndex)} className="form-input-modern"><option value="left">Left</option><option value="center">Center</option><option value="right">Right</option></select></div>
                                  </div>
                                  <div className="flex-row" style={{ marginTop: '1rem', display: 'flex', gap: '1.5rem', flexWrap: 'wrap' }}>
                                    <div className="badge-toggle" style={{ padding: '0.2rem 1rem' }}><div className="checkbox-toggle-modern"><input type="checkbox" name="show_for_name" checked={section.ender_config?.show_for_name || false} onChange={(e) => handleEnderConfigChange(e, originalIndex)} id={`forName_${originalIndex}`} /></div><label htmlFor={`forName_${originalIndex}`} style={{ cursor: 'pointer' }}>Show "For" Name</label></div>
                                    {section.ender_config?.show_for_name && <div><label className="form-label-modern">For Name</label><input name="for_name" type="text" className="form-input-modern" value={section.ender_config?.for_name} onChange={(e) => handleEnderConfigChange(e, originalIndex)} /></div>}
                                    <div className="badge-toggle"><div className="checkbox-toggle-modern"><input type="checkbox" name="show_assigning_authority" checked={section.ender_config?.show_assigning_authority || false} onChange={(e) => handleEnderConfigChange(e, originalIndex)} id={`assignAuth_${originalIndex}`} /></div><label htmlFor={`assignAuth_${originalIndex}`}>Show Signatory Authority Details</label></div>
                                  </div>
                                  {section.ender_config?.show_assigning_authority && (
                                    <div style={{ marginTop: '1rem', paddingLeft: '1rem', borderLeft: '2px solid #e2e8f0' }}>
                                      <div className="flex-row" style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}><div className="badge-toggle"><div className="checkbox-toggle-modern"><input type="checkbox" name="show_authority_name" checked={section.ender_config?.show_authority_name || false} onChange={(e) => handleEnderConfigChange(e, originalIndex)} id={`authName_${originalIndex}`} /></div><label htmlFor={`authName_${originalIndex}`}>Authority Name</label></div>
                                        {section.ender_config?.show_authority_name && <><select name="authority_name_position" value={section.ender_config?.authority_name_position || ""} onChange={(e) => handleEnderConfigChange(e, originalIndex)} className="form-input-modern"><option value="top">Top</option><option value="bottom">Bottom</option></select><select name="authority_name_alignment" value={section.ender_config?.authority_name_alignment || ""} onChange={(e) => handleEnderConfigChange(e, originalIndex)} className="form-input-modern"><option value="left">Left</option><option value="center">Center</option><option value="right">Right</option></select></>}</div>
                                      <div className="flex-row" style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', marginTop: '0.5rem' }}><div className="badge-toggle"><div className="checkbox-toggle-modern"><input type="checkbox" name="show_authority_designation" checked={section.ender_config?.show_authority_designation || false} onChange={(e) => handleEnderConfigChange(e, originalIndex)} id={`authDes_${originalIndex}`} /></div><label htmlFor={`authDes_${originalIndex}`}>Authority Designation</label></div>
                                        {section.ender_config?.show_authority_designation && <><select name="authority_designation_position" value={section.ender_config?.authority_designation_position || ""} onChange={(e) => handleEnderConfigChange(e, originalIndex)} className="form-input-modern"><option value="top">Top</option><option value="bottom">Bottom</option></select><select name="authority_designation_alignment" value={section.ender_config?.authority_designation_alignment || ""} onChange={(e) => handleEnderConfigChange(e, originalIndex)} className="form-input-modern"><option value="left">Left</option><option value="center">Center</option><option value="right">Right</option></select></>}</div>
                                    </div>
                                  )}
                                </div>
                              )}
                              {section.ender_config?.ender_type === "note" && (
                                <div><label className="form-label-modern">Note Text</label><textarea name="note_text" value={section.ender_config?.note_text || ""} onChange={(e) => handleEnderConfigChange(e, originalIndex)} className="form-input-modern" rows={3} /></div>
                              )}
                              {section.ender_config?.ender_type === "default" && (
                                <div style={{ background: '#eff6ff', padding: '0.75rem', borderRadius: '12px', textAlign: 'center', color: '#1e40af' }}><b>*This is a software generated slip. No signature required*</b></div>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                )} */}
              </form>
              <div className="button-models">
                <button
                  className="model-button model-button-cancel font-weight500"
                  onClick={handleClose}
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  className="model-button model-button-leave font-weight500 font-size-heading"
                  disabled={loading}
                  onClick={handleSubmit}
                >
                  {loading ? "Creating..." : "Create Slip Template"}
                </button>
              </div>
            </div>

            <p className="error-message font-size-text">
              {isSubmitted && Object.keys(errors).length > 0 && (
                Object.keys(errors).length > 5 ? (
                  <h5 className="text-center">Please fill all mandatory fields!</h5>
                ) : (
                  <h6 className="text-center">
                    {Object.keys(errors)
                      ?.map((field) =>
                        field
                          .replace(/_/g, ' ')
                          .replace(/\b\w/g, (char) => char.toUpperCase())
                      )
                      .join(', ') + ' are required!'}
                  </h6>
                )
              )}
            </p>
          </div>
        </Modal.Body >
      </Modal >

      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
};


const SectionCard = ({
  section,
  sectionIndex,
  originalSectionIndex,
  totalSections,
  handleSectionChange,
  handleSectionPositionChange,
  removeSection,
  children
}) => {
  return (
    <div className="section-card">
      <div className="slip-card-header">
        <h4>Section {sectionIndex + 1}</h4>

        <button
          type="button"
          className="required"
          onClick={() => removeSection(originalSectionIndex)}
        >
          <CrosswithRedCircle /> Remove
        </button>
      </div>

      <div className="form-flex-wrap">
        <div className="flex-column">
          <label className="form-label">Section Order</label>
          <select
            name="order"
            value={section.order}
            onChange={(e) => handleSectionPositionChange(e, originalSectionIndex)}
            className="form-input-date"
          >
            {Array.from({ length: totalSections }, (_, i) => (
              <option key={i + 1} value={i + 1}>{i + 1}</option>
            ))}
          </select>
        </div>

        <div className="flex-column">
          <label className="form-label">Title</label>
          <input
            type="text"
            name="title"
            value={section.title}
            onChange={(e) => handleSectionChange(e, originalSectionIndex)}
            className="form-input"
            placeholder="Section title"
          />
        </div>
      </div>

      {children}
    </div>
  );
};

const CompartmentCard = ({
  compartment,
  compIndex,
  section,
  originalSectionIndex,
  handleCompartmentChange,
  handleCompartmentPositionChange,
  removeCompartment,
  children,
  layoutTypes,
}) => {
  return (
    <div className="compartment-card">
      <div className="slip-card-header">
        <h5>Compartment {compIndex + 1}</h5>

        <button
          type="button"
          className="required"
          onClick={() => removeCompartment(originalSectionIndex, compIndex)}
        >
          <CrosswithRedCircle /> Remove
        </button>
      </div>

      <div className="form-flex-wrap">
        <div className="flex-column">
          <label className="form-label">Order</label>
          <select
            name="order"
            value={compartment.order}
            onChange={(e) =>
              handleCompartmentPositionChange(e, originalSectionIndex, compIndex)
            }
            className="form-input-date"
          >
            {Array.from({ length: section.compartments.length }, (_, i) => (
              <option key={i + 1} value={i + 1}>{i + 1}</option>
            ))}
          </select>
        </div>

        <div className="flex-column">
          <label className="form-label">Layout</label>
          <select
            name="layout_type"
            value={compartment.layout_type}
            onChange={(e) =>
              handleCompartmentChange(e, originalSectionIndex, compIndex)
            }
            className="form-input-date"
          >
            {layoutTypes.map(layout => (
              <option key={layout.value} value={layout.value}>
                {layout.label}
              </option>
            ))}
          </select>
        </div>

        {compartment.layout_type === "columns" && (
          <div className="flex-column">
            <label className="form-label">Columns</label>
            <select
              name="columns"
              value={compartment.columns}
              onChange={(e) =>
                handleCompartmentChange(e, originalSectionIndex, compIndex)
              }
              className="form-input-date"
            >
              {[2, 3].map(num => (
                <option key={num} value={num}>{num}</option>
              ))}
            </select>
          </div>
        )}
      </div>

      {children}
    </div>
  );
};

const FieldCard = ({
  field,
  fieldIndex,
  compartment,
  originalSectionIndex,
  compIndex,
  originalFieldIndex,
  handleFieldChange,
  handleFieldPositionChange,
  removeField
}) => {
  return (
    <div className="field-card">
      <div className="slip-card-header">
        <h6>Field {fieldIndex + 1}</h6>

        <button
          type="button"
          className="required"
          onClick={() =>
            removeField(originalSectionIndex, compIndex, originalFieldIndex)
          }
        >
          <CrosswithRedCircle /> Remove
        </button>
      </div>

      <div className="form-flex-wrap">

        <div className="flex-column">
          <label>Order</label>
          <select
            name="order"
            value={field.order}
            onChange={(e) =>
              handleFieldPositionChange(e, originalSectionIndex, compIndex, originalFieldIndex)
            }
            className="form-input-date"
          >
            {(() => {
              const col = field.column_position || 1;
              const list = compartment.fields.filter(
                f => (f.column_position || 1) === col
              );
              return list.map((_, i) => (
                <option key={i + 1} value={i + 1}>{i + 1}</option>
              ));
            })()}
          </select>
        </div>

        {compartment.layout_type === "columns" && (
          <div className="flex-column">
            <label>Column</label>
            <select
              name="column_position"
              value={field.column_position}
              onChange={(e) =>
                handleFieldChange(e, originalSectionIndex, compIndex, originalFieldIndex)
              }
              className="form-input-date"
            >
              {Array.from({ length: compartment.columns }, (_, i) => (
                <option key={i + 1} value={i + 1}>{i + 1}</option>
              ))}
            </select>
          </div>
        )}

        <div className="flex-column">
          <label>Category</label>
          <input
            type="text"
            name="category"
            value={field.category}
            onChange={(e) =>
              handleFieldChange(e, originalSectionIndex, compIndex, originalFieldIndex)
            }
            className="form-input"
          />
        </div>

        <div className="flex-column">
          <label>Label</label>
          <input
            type="text"
            name="label"
            value={field.label}
            onChange={(e) =>
              handleFieldChange(e, originalSectionIndex, compIndex, originalFieldIndex)
            }
            className="form-input"
          />
        </div>

        <div className="flex-column">
          <label>Value</label>
          <input
            type="text"
            name="value_key"
            value={field.value_key}
            onChange={(e) =>
              handleFieldChange(e, originalSectionIndex, compIndex, originalFieldIndex)
            }
            className="form-input"
          />
        </div>

      </div>
    </div>
  );
};


const UpdateSlipBuildDetails = ({
  i,
  SUPER_ADMIN,
  SUB_COMPANIES,
  getSlipBuilderData,
  LETTER_TEMPLATES,
  empList
}) => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [buffer, setBuffering] = useState(true);
  const [previewShow, setPreviewShow] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [slipBuilderCategories, setSlipBuilderCategories] = useState([]);
  const handleClose = () => {
    setShow(false);
    setPreviewShow(false);
  };


  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const initialFormData = {
    name: "",
    description: "",
    is_default: false,
    sub_company: sessionStorage.getItem("company_id"),
    letter_template: "",
    category: "",
    starter_display: false,
    body_display: false,
    ender_display: false,
    updated_by: sessionStorage.getItem('emp_code'),
    sections: [
      {
        section_type: "starter",
        order: 1,
        title: "",
        compartments: [
          {
            layout_type: "full",
            order: 1,
            fields: []
          }
        ]
      },
      {
        section_type: "body",
        order: 2,
        title: "",
        compartments: [
          {
            layout_type: "full",
            columns: 2,
            order: 1,
            fields: []
          }
        ]
      },
      {
        section_type: "ender",
        order: 3,
        title: "",
        compartments: [],

        ender_config: {
          ender_type: "default",
          note_text: "",
          show_for_name: false,
          for_name: "",
          for_name_position: "top",
          for_name_alignment: "center",

          show_assigning_authority: false,
          signature_authority: "",// emp_code
          show_authority_name: false,
          show_authority_designation: false,

          authority_name_position: "bottom",
          authority_name_alignment: "left",

          authority_designation_position: "bottom",
          authority_designation_alignment: "left"
        }
      }
    ]
  };
  const [formData, setFormData] = useState(initialFormData);
  const [lettersTemplate, setLettersTemplateData] = useState([]);


  // useEffect(() => {
  //   if (i) {
  //     setFormData({
  //       ...i,

  //       letter_template_id: i.letter_template,
  //       letter_template_name: i.letter_template_name,


  //       category_id: i.category?.id,
  //       category_name: i.category?.name,


  //       sub_company_id: i.sub_company,
  //       sub_company_title: i.sub_company_title,
  //     });
  //   }
  // }, [i]);

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = ["name", "category", "letter_template"];

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
      }
    });

    setErrors(newErrors);
    setIsSubmitted(true);
    return Object.keys(newErrors).length === 0;
  };


  const getLetterTemplatesList = async () => {

    try {
      const template = await axios.get(
        `${BASE_URL}/wfm/letter-builder-template-bysubcompany/${formData?.sub_company}/`
      );
      setLettersTemplateData(template.data);
    } catch (err) {
      handleErrorToast(err);
    }
  };

  const getSlipBuilderCategories = async () => {
    try {
      setBuffering(true);
      const res = await axios.get(`${BASE_URL}/wfm/slip-category-data-by-subcompany/${formData?.sub_company}/`);
      setSlipBuilderCategories(res.data);
    } catch (error) {
      console.error(error);
    } finally {
      setBuffering(false);
    }
  }

  // const handleShow = () => {
  //   setShow(true);
  //   getLetterTemplatesList();
  //   getSlipBuilderCategories();
  //   setFormData(i);
  //   const formData = { ...initialFormData };


  //   const starterExists = formData.sections.some(section => section.section_type === "starter");
  //   const bodyExists = formData.sections.some(section => section.section_type === "body");
  //   const enderExists = formData.sections.some(section => section.section_type === "ender");

  //   formData.starter_display = starterExists;
  //   formData.body_display = bodyExists;
  //   formData.ender_display = enderExists;

  // }
  const handleShow = () => {
    setShow(true);
    getLetterTemplatesList();
    getSlipBuilderCategories();

    const starterExists = i.sections?.some(section => section.section_type === "starter");
    const bodyExists = i.sections?.some(section => section.section_type === "body");
    const enderExists = i.sections?.some(section => section.section_type === "ender");

    setFormData({
      ...i,
      starter_display: starterExists,
      body_display: bodyExists,
      ender_display: enderExists,
    });
  };




  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;



    const displayToSection = {
      starter_display: "starter",
      body_display: "body",
      ender_display: "ender"
    };


    const getSectionTemplate = (type) => {
      switch (type) {
        case "starter":
          return {
            section_type: "starter",
            order: 1,
            title: "",
            compartments: [
              {
                layout_type: "full",
                order: 1,
                fields: []
              }
            ]
          };
        case "body":
          return {
            section_type: "body",
            order: 2,
            title: "",
            compartments: [
              {
                layout_type: "full",
                columns: 2,
                order: 1,
                fields: []
              }
            ]
          };
        case "ender":
          return {
            section_type: "ender",
            order: 3,
            title: "",
            compartments: [],
            ender_config: {
              ender_type: "default",
              note_text: "",
              show_for_name: false,
              for_name: "",
              for_name_position: "top",
              for_name_alignment: "center",
              show_assigning_authority: false,
              signature_authority: "",
              show_authority_name: false,
              show_authority_designation: false,
              authority_name_position: "bottom",
              authority_name_alignment: "left",
              authority_designation_position: "bottom",
              authority_designation_alignment: "left"
            }
          };
        default:
          return null;
      }
    };


    // if (name === "category") {
    //   setFormData((prev) => ({
    //     ...prev,
    //     category: {
    //       ...prev.category,
    //       id: value
    //     }
    //   }));
    //   return;
    // }

    if (displayToSection[name]) {
      const sectionType = displayToSection[name];

      setFormData((prev) => {
        let newSections = checked
          ? [...prev.sections, getSectionTemplate(sectionType)].filter(
            (s, i, arr) =>
              arr.findIndex((sec) => sec.section_type === s.section_type) === i
          )
          : prev.sections.filter((s) => s.section_type !== sectionType);

        return {
          ...prev,
          [name]: checked,
          sections: newSections.length ? newSections : []
        };
      });
      return;
    }



    setFormData((prev) => {
      if (!prev.starter_display && !prev.body_display && !prev.ender_display) {
        return {
          ...prev,
          sections: [],
          [name]: type === "checkbox" ? checked : value
        };
      }

      return {
        ...prev,
        [name]: type === "checkbox" ? checked : value
      };
    });




    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : ""
    });

    if (value.trim()) {
      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[name];
        return updatedErrors;
      });
    }
  };

  // const handleChange = (e) => {
  //   const { name, value, type, checked } = e.target;

  //   const displayToSection = {
  //     starter_display: "starter",
  //     body_display: "body",
  //     ender_display: "ender"
  //   };

  //   const getSectionTemplate = (type) => {
  //     switch (type) {
  //       case "starter":
  //         return {
  //           section_type: "starter",
  //           order: 1,
  //           title: "",
  //           compartments: [
  //             {
  //               layout_type: "full",
  //               order: 1,
  //               fields: []
  //             }
  //           ]
  //         };
  //       case "body":
  //         return {
  //           section_type: "body",
  //           order: 2,
  //           title: "",
  //           compartments: [
  //             {
  //               layout_type: "full",
  //               columns: 2,
  //               order: 1,
  //               fields: []
  //             }
  //           ]
  //         };
  //       case "ender":
  //         return {
  //           section_type: "ender",
  //           order: 3,
  //           title: "",
  //           compartments: [],
  //           ender_config: {
  //             ender_type: "default",
  //             note_text: "",
  //             show_for_name: false,
  //             for_name: "",
  //             for_name_position: "top",
  //             for_name_alignment: "center",
  //             show_assigning_authority: false,
  //             signature_authority: "",
  //             show_authority_name: false,
  //             show_authority_designation: false,
  //             authority_name_position: "bottom",
  //             authority_name_alignment: "left",
  //             authority_designation_position: "bottom",
  //             authority_designation_alignment: "left"
  //           }
  //         };
  //       default:
  //         return null;
  //     }
  //   };

  //   if (displayToSection[name]) {
  //     const sectionType = displayToSection[name];

  //     setFormData((prev) => {
  //       let newSections = checked
  //         ? [...prev.sections, getSectionTemplate(sectionType)].filter(
  //           (s, i, arr) =>
  //             arr.findIndex((sec) => sec.section_type === s.section_type) === i
  //         )
  //         : prev.sections.filter((s) => s.section_type !== sectionType);


  //       return {
  //         ...prev,
  //         [name]: checked,
  //         sections: newSections
  //       };
  //     });

  //     return;
  //   }


  //   setFormData((prev) => ({
  //     ...prev,
  //     [name]: type === "checkbox" ? checked : value,
  //   }));


  //   setInputState({
  //     ...inputState,
  //     [name]: value.trim() ? "green" : ""
  //   });

  //   if (value.trim()) {
  //     setErrors((prevErrors) => {
  //       const updatedErrors = { ...prevErrors };
  //       delete updatedErrors[name];
  //       return updatedErrors;
  //     });
  //   }
  // };


  const addSection = () => {
    setFormData(prev => {
      const updatedSections = [...prev.sections];

      updatedSections.push({
        section_type: "starter",
        order: updatedSections.length + 1,
        title: "",
        compartments: [
          {
            order: 1,
            layout_type: "full",
            fields: []
          }
        ],
        // ender_config: null
      });

      return {
        ...prev,
        sections: updatedSections
      };
    });
  };

  const handleSectionChange = (e, sectionIndex) => {
    const { name, value } = e.target;

    setFormData(prev => {
      const updatedSections = [...prev.sections];
      updatedSections[sectionIndex] = {
        ...updatedSections[sectionIndex],
        [name]: value
      };

      return {
        ...prev,
        sections: updatedSections
      };
    });
  };

  const removeSection = (sectionIndex) => {
    setFormData(prev => {
      const updatedSections = [...prev.sections];
      updatedSections.splice(sectionIndex, 1);

      // Reorder section order values
      updatedSections.forEach((section, index) => {
        section.order = index + 1;
      });

      return {
        ...prev,
        sections: updatedSections
      };
    });
  };


  // Add a new compartment to a section
  const addCompartment = (sectionIndex) => {
    setFormData(prev => {
      const updatedSections = [...prev.sections];
      const updatedCompartments = [...updatedSections[sectionIndex].compartments];

      updatedCompartments.push({
        order: updatedCompartments.length + 1,
        layout_type: "full",
        // columns: 2,
        fields: []
      });

      updatedSections[sectionIndex] = {
        ...updatedSections[sectionIndex],
        compartments: updatedCompartments
      };

      return {
        ...prev,
        sections: updatedSections
      };
    });
  };


  // Handle compartment change (layout_type, columns, etc.)
  const handleCompartmentChange = (e, sectionIndex, compartmentIndex) => {
    const { name, value } = e.target;

    setFormData(prev => {
      const updatedSections = [...prev.sections];
      const updatedCompartments = [...updatedSections[sectionIndex].compartments];

      updatedCompartments[compartmentIndex] = {
        ...updatedCompartments[compartmentIndex],
        [name]: name === "columns" ? parseInt(value) : value
      };

      updatedSections[sectionIndex] = {
        ...updatedSections[sectionIndex],
        compartments: updatedCompartments
      };

      return {
        ...prev,
        sections: updatedSections
      };
    });
  };

  // Remove compartment
  const removeCompartment = (sectionIndex, compartmentIndex) => {
    setFormData(prev => {
      const updatedSections = [...prev.sections];
      const updatedCompartments = [...updatedSections[sectionIndex].compartments];

      updatedCompartments.splice(compartmentIndex, 1);

      // Reorder compartments
      updatedCompartments.forEach((comp, index) => {
        comp.order = index + 1;
      });

      updatedSections[sectionIndex] = {
        ...updatedSections[sectionIndex],
        compartments: updatedCompartments
      };

      return {
        ...prev,
        sections: updatedSections
      };
    });
  };


  const addFieldToCompartment = (sectionIndex, compartmentIndex) => {
    setFormData(prev => {
      const updatedSections = [...prev.sections];
      const updatedCompartments = [...updatedSections[sectionIndex].compartments];
      const updatedFields = [...updatedCompartments[compartmentIndex].fields];

      updatedFields.push({
        label: "",
        label_alignment: "left",
        category: "",
        value_key: "",
        value_alignment: "left",
        order: updatedFields.length + 1
      });

      updatedCompartments[compartmentIndex] = {
        ...updatedCompartments[compartmentIndex],
        fields: updatedFields
      };

      updatedSections[sectionIndex] = {
        ...updatedSections[sectionIndex],
        compartments: updatedCompartments
      };

      return {
        ...prev,
        sections: updatedSections
      };
    });
  };

  const handleFieldChange = (e, sectionIndex, compartmentIndex, fieldIndex) => {
    const { name, value } = e.target;

    setFormData(prev => {
      const updatedSections = [...prev.sections];
      const updatedCompartments = [...updatedSections[sectionIndex].compartments];
      const updatedFields = [...updatedCompartments[compartmentIndex].fields];

      updatedFields[fieldIndex] = {
        ...updatedFields[fieldIndex],
        [name]: value
      };

      updatedCompartments[compartmentIndex] = {
        ...updatedCompartments[compartmentIndex],
        fields: updatedFields
      };

      updatedSections[sectionIndex] = {
        ...updatedSections[sectionIndex],
        compartments: updatedCompartments
      };

      return {
        ...prev,
        sections: updatedSections
      };
    });
  };

  const removeField = (sectionIndex, compartmentIndex, fieldIndex) => {
    setFormData(prev => {
      const updatedSections = [...prev.sections];
      const updatedCompartments = [...updatedSections[sectionIndex].compartments];
      const updatedFields = [...updatedCompartments[compartmentIndex].fields];

      updatedFields.splice(fieldIndex, 1);

      // Update positions
      updatedFields.forEach((field, index) => {
        field.order = index + 1;
      });

      updatedCompartments[compartmentIndex] = {
        ...updatedCompartments[compartmentIndex],
        fields: updatedFields
      };

      updatedSections[sectionIndex] = {
        ...updatedSections[sectionIndex],
        compartments: updatedCompartments
      };

      return {
        ...prev,
        sections: updatedSections
      };
    });
  };



  const handleEnderConfigChange = (e, sectionIndex) => {
    const { name, type, checked, value } = e.target;

    setFormData((prev) => {
      const updatedSections = prev.sections.map((section, idx) => {
        if (idx !== sectionIndex) return section;
        console.log('idx !== sectionIndex', idx !== sectionIndex)
        console.log('name', name)
        console.log('value', value)
        console.log('section.ender_config', section.ender_config)
        return {
          ...section,
          ender_config: {
            ...section.ender_config,
            [name]: type === "checkbox" ? checked : value
          }
        };
      });

      return {
        ...prev,
        sections: updatedSections
      };
    });


  };

  const handleSectionPositionChange = (e, index) => {
    const newPosition = parseInt(e.target.value);
    setFormData((prev) => ({
      ...prev,
      sections: ReorderList(
        prev.sections,   // prevItems
        index,           // index of moved item
        newPosition,     // new position
        'order'
      ),
    }));
  };

  const handleCompartmentPositionChange = (e, sectionIndex, compartmentIndex) => {
    const newPosition = parseInt(e.target.value);

    setFormData((prev) => {
      const updatedSections = [...prev.sections];
      const section = updatedSections[sectionIndex];

      // Ensure compartments array exists
      if (!section.compartments) {
        section.compartments = [];
      }

      const updatedCompartments = ReorderList(
        section.compartments,   // compartments array
        compartmentIndex,       // index of moved compartment
        newPosition,            // new position
        'order'
      );

      // Update the section with reordered compartments
      updatedSections[sectionIndex] = {
        ...section,
        compartments: updatedCompartments
      };

      return {
        ...prev,
        sections: updatedSections
      };
    });
  };

  const handleFieldPositionChange = (e, sectionIndex, compartmentIndex, fieldIndex) => {
    const newPosition = parseInt(e.target.value);

    setFormData((prev) => {
      const updatedSections = [...prev.sections];
      const section = updatedSections[sectionIndex];

      // Ensure compartments and fields arrays exist
      if (!section.compartments || !section.compartments[compartmentIndex]) {
        return prev; // Safety check
      }

      const compartment = section.compartments[compartmentIndex];

      if (!compartment.fields) {
        compartment.fields = [];
      }

      const updatedFields = ReorderList(
        compartment.fields,     // fields array
        fieldIndex,            // index of moved field
        newPosition,           // new position
        'order'                // or 'position' depending on your field structure
      );

      // Update the compartment with reordered fields
      updatedSections[sectionIndex].compartments[compartmentIndex] = {
        ...compartment,
        fields: updatedFields
      };

      return {
        ...prev,
        sections: updatedSections
      };
    });
  };

  const layoutTypes = [
    { value: "full", label: "Full Width" },
    { value: "columns", label: "Multi Columns" }
  ];

  const alignmentChoices = [
    { value: "left", label: "Left" },
    { value: "center", label: "Center" },
    { value: "right", label: "Right" }
  ];


  const handleSubmit = async (e) => {
    e.preventDefault();
    // if (validateForm()) {
    setLoading(true);

    const loadingToastId = toast.loading("Loading: Please wait...");

    try {
      let res;
      const { starter_display, body_display, ender_display, ...submitData } = formData;
      if (formData?.id) {
        res = await axios.put(
          `${BASE_URL}/wfm/slip-builder-update/${formData?.id}/`,
          submitData,
          // {
          //   headers: {
          //     "Content-Type": "multipart/form-data",
          //   },
          // }
        );
      }

      if (res.status === 200) {
        await getSlipBuilderData();
        setShow(false);
        toast.success("Slip Template updated successfully!");
      } else {
        alert(res);
      }
    } catch (err) {
      handleErrorToast(err, loadingToastId);
    } finally {
      setLoading(false);
      toast.dismiss(loadingToastId);
    }
    // }
  };


  return (
    <>
      {i?.id && (
        <button
          title="Update Slip Template"
          className="model-edit-button-ml"
          onClick={handleShow}
        >
          <UpdatePencil />
        </button>
      )}

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="five-sixth-modal"
      >
        <Modal.Header closeButton>
          <div className="flex-row w-full justify-between">
            <Modal.Title>
              Update Slip Template -{" "}
              <span className="dynamic-modal-title">
                {" "}
                {i?.name}{" "}
              </span>
            </Modal.Title>
            <div className="flex-row">

              <label htmlFor="isDefault" className="font-weight500 font-size-subheading">
                {formData.is_default ? "Is" : "Is Not"} Default
              </label>
              <hr className="field-cont-hr" />
              <div className="checkbox-toggle">
                <input
                  type="checkbox"
                  name="is_default"
                  checked={formData.is_default}
                  onChange={handleChange}
                  id="isDefault"
                />
                <label htmlFor={`isDefault`}></label>
              </div>
              <hr className="field-cont-hr" />
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>

          <div className="parent-div">
            <div className="bdy-div">
              <form className="">
                {/* Basic Information */}


                <div className="form-flex-wrap">
                  {SUPER_ADMIN && (
                    <div className="flex-column">
                      <label className="form-labels font-weight500 font-size-subheading">
                        Sub Company
                      </label>
                      <select
                        name="sub_company"
                        value={formData.sub_company}
                        onChange={handleChange}
                        className="form-input"
                      >
                        <option value="">Select a Company</option>
                        {SUB_COMPANIES?.map((company) => (
                          <option key={company.id} value={company.id}>
                            {company.title}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                  <div className="flex-column ">
                    <label className="form-labels font-weight500 font-size-subheading">
                      Template Name<span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      name="name"
                      placeholder="Template Name"
                      value={formData.name}
                      onChange={handleChange}
                      className={`form-input ${errors.name ? "error" : inputState.name ? "success" : ""}`}
                      required
                    />
                    {errors.name && (
                      <span className="error-message font-size-text ">
                        {errors.name}
                      </span>
                    )}
                  </div>

                  <div className="flex-column">
                    <label className="form-labels font-weight500 font-size-subheading">
                      Description
                    </label>
                    <textarea
                      name="description"
                      placeholder="Description"
                      value={formData.description}
                      onChange={handleChange}
                      className="form-input"
                      rows={3}
                    />
                  </div>

                  <div className="flex-column">
                    <label className="form-labels font-weight500 font-size-subheading">
                      Category<span className="required">*</span>
                    </label>
                    <select
                      name="category"
                      value={formData.category || ""}
                      onChange={handleChange}
                      className={`form-input ${errors.category ? "error" : inputState.category ? "success" : ""}`}
                      required
                    >
                      <option value="">Select Category</option>
                      {slipBuilderCategories?.map((category) => (
                        <option key={category.id} value={category.id}>
                          {category.name}
                        </option>
                      ))}
                    </select>
                    {errors.category && (
                      <span className="error-message font-size-text ">
                        {errors.category}
                      </span>
                    )}
                  </div>



                  <div className="flex-column">
                    <label className="form-labels font-weight500 font-size-subheading">
                      Letter Template<span className="required">*</span>
                      {formData.letter_template && <ViewLetterBuilder
                        buttonDisplay={'Eye-Name'}
                        templateID={formData.letter_template}
                      />}
                    </label>
                    <select
                      name="letter_template"
                      value={formData.letter_template || ""}
                      onChange={handleChange}
                      className={`form-input ${errors?.letter_template ? "error" : inputState.letter_template ? "success" : ""}`}
                      required
                    >
                      <option value="">Select Template</option>
                      {lettersTemplate?.map((template) => (
                        <option key={template.id} value={template.id}>
                          {template.template_name}
                        </option>
                      ))}
                    </select>
                    {errors.letter_template && (
                      <span className="error-message font-size-text ">
                        {errors.letter_template}
                      </span>
                    )}
                  </div>
                </div>

                <div className="flex-row justify-evenly" style={{ width: "100%" }}>

                  <div className="flex-row">
                    <div className="checkbox-toggle">
                      <input
                        type="checkbox"
                        name="starter_display"
                        checked={formData.starter_display}
                        onChange={handleChange}
                        id="starterDisplay"
                      />
                      <label htmlFor="starterDisplay"></label>
                    </div>
                    <hr className="field-cont-hr" />
                    <label htmlFor="starterDisplay" className="font-weight500 font-size-subheading">
                      {formData.starter_display ? "Show" : "Hide"} Custom Sections
                    </label>
                  </div>


                  <div className="flex-row">
                    <div className="checkbox-toggle">
                      <input
                        type="checkbox"
                        name="body_display"
                        checked={formData.body_display}
                        onChange={handleChange}
                        id="bodyDisplay"
                      />
                      <label htmlFor="bodyDisplay"></label>
                    </div>
                    <hr className="field-cont-hr" />
                    <label htmlFor="bodyDisplay" className="font-weight500 font-size-subheading">
                      {formData.body_display ? "Show" : "Hide"} Custom Body
                    </label>
                  </div>


                  <div className="flex-row">
                    <div className="checkbox-toggle">
                      <input
                        type="checkbox"
                        name="ender_display"
                        checked={formData.ender_display}
                        onChange={handleChange}
                        id="enderDisplay"
                      />
                      <label htmlFor="enderDisplay"></label>
                    </div>
                    <hr className="field-cont-hr" />
                    <label htmlFor="enderDisplay" className="font-weight500 font-size-subheading">
                      {formData.ender_display ? "Show" : "Hide"} Custom Ender
                    </label>
                  </div>
                </div>
                {formData.starter_display && <>
                  <div className="jd-heading-outer heading-bg-color-white">
                    <div className="jd-heading-outer-flex">
                      <h2 className="jd-heading-main font-weight600  font-size-heading">
                        Starter Section Configuration
                      </h2>
                    </div>
                    <div>
                      <div className="jd-heading-bottom-bold"></div>
                      <div className="jd-heading-bottom-light"></div>
                    </div>
                  </div>
                  <ol>
                    {formData.sections?.length > 0 && formData.sections
                      ?.filter(sec => sec.section_type === "starter")
                      .map((section, sectionIndex) => {
                        const originalSectionIndex = formData.sections.findIndex(sec => sec === section);
                        return (
                          <div key={originalSectionIndex}>
                            <li>
                              <div className="flex-row justify-between">
                                Section {sectionIndex + 1}{" "}
                                <button
                                  type="button"
                                  className="required"
                                  onClick={() => removeSection(originalSectionIndex)}
                                >
                                  <CrosswithRedCircle /><span className="ms-1">Remove Section</span>
                                </button>
                              </div>
                              <div className="form-flex-wrap">

                                <div className="flex-column">
                                  <label className="form-label">Section Order</label>
                                  <select
                                    name="order"
                                    value={section.order}
                                    // onChange={(e) => handleSectionPositionChange(e, originalSectionIndex)}
                                    onChange={(e) => handleSectionPositionChange(e, originalSectionIndex)}
                                    className="form-input-date"
                                  >
                                    {Array.from({ length: formData.sections?.filter(sec => sec.section_type === "starter")?.length }, (_, i) => (
                                      <option key={i + 1} value={i + 1}>
                                        {i + 1}
                                      </option>
                                    ))}
                                  </select>
                                </div>

                                <div className="flex-column">
                                  <label className="form-label">Title</label>
                                  <input
                                    type="text"
                                    name="title"
                                    value={section.title}
                                    onChange={(e) => handleSectionChange(e, originalSectionIndex)}
                                    className="form-input"
                                    placeholder="Section title"
                                  />
                                </div>
                              </div>

                              <div className="flex-row">
                                <hr className="line" />
                                <b className="w-52-percent text-center">
                                  {section.title ? `Section "${section.title}"` : `Section ${sectionIndex + 1}`} Compartments
                                </b>
                                <hr className="line" />
                              </div>
                            </li>

                            <ol className="ps-0">
                              {section.compartments?.length > 0 ?
                                (
                                  section.compartments?.map((compartment, compIndex) =>
                                  (
                                    <div key={compIndex} className="compartment-card">
                                      <li>
                                        <div >
                                          <div className="flex-row justify-between">
                                            Compartment {compIndex + 1}{" "}
                                            <button
                                              type="button"
                                              className="required"
                                              onClick={() => removeCompartment(originalSectionIndex, compIndex)}
                                            >
                                              <CrosswithRedCircle /><span className="ms-1">Remove Compartment</span>
                                            </button>
                                          </div>

                                          <div className="form-flex-wrap">
                                            <div className="flex-column">
                                              <label className="form-label">Compartment Order</label>
                                              <select
                                                name="order"
                                                value={compartment.order}
                                                onChange={(e) => handleCompartmentPositionChange(e, originalSectionIndex, compIndex)}
                                                className="form-input-date"
                                              // style={{ width: '60px' }}
                                              >
                                                {Array.from({ length: section.compartments?.length }, (_, i) => (
                                                  <option key={i + 1} value={i + 1}>
                                                    {i + 1}
                                                  </option>
                                                ))}
                                              </select>
                                            </div>
                                            <div className="flex-column">
                                              <label className="form-label">Compartment Layout Type</label>
                                              <select
                                                name="layout_type"
                                                value={compartment.layout_type}
                                                onChange={(e) => handleCompartmentChange(e, originalSectionIndex, compIndex)}
                                                className="form-input-date"
                                              >
                                                {layoutTypes?.map(layout => (
                                                  <option key={layout.value} value={layout.value}>
                                                    {layout.label}
                                                  </option>
                                                ))}
                                              </select>
                                            </div>


                                            {compartment.layout_type === "columns" && (
                                              <div className="flex-row">
                                                <div className="flex-column">
                                                  <label className="form-label">Number of Columns</label>
                                                  <select
                                                    name="columns"
                                                    value={compartment.columns}
                                                    onChange={(e) => handleCompartmentChange(e, originalSectionIndex, compIndex)}
                                                    className="form-input-date"
                                                  >
                                                    <option value=''>Select No. of columns</option>
                                                    {/* {Array.from({ length: 5 }, (_, i) => (
                                                      <option key={i + 2} value={i + 2}>
                                                        {i + 2}
                                                      </option>
                                                    ))} */}
                                                    {[2, 3].map(num => (
                                                      <option key={num} value={num}>
                                                        {num}
                                                      </option>
                                                    ))}

                                                  </select>
                                                </div>

                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      </li>

                                      <div className="flex-row">
                                        <hr className="line" />
                                        <b className="w-52-percent text-center">
                                          {`Compartment ${compIndex + 1} `} Fields
                                        </b>
                                        <hr className="line" />
                                      </div>

                                      <ol className="ps-0">
                                        {compartment.fields?.length > 0
                                          ?
                                          (
                                            compartment.fields.map((field, fieldIndex) => (
                                              <div key={fieldIndex} className="field-card">
                                                <li>
                                                  <div className="info" >
                                                    <div className="flex-row justify-between">
                                                      Field {fieldIndex + 1}{" "}
                                                      <button
                                                        type="button"
                                                        className="required"
                                                        onClick={() => removeField(originalSectionIndex, compIndex, fieldIndex)}
                                                      >
                                                        <CrosswithRedCircle /><span className="ms-1">Remove Field</span>
                                                      </button>
                                                    </div>
                                                    <div className="form-flex-wrap">

                                                      <div className="flex-column">
                                                        <label className="form-label">Field Order</label>
                                                        <select
                                                          name="order"
                                                          value={field.order}
                                                          onChange={(e) => handleFieldPositionChange(e, originalSectionIndex, compIndex, fieldIndex)}
                                                          className="form-input-date"
                                                        >
                                                          {Array.from({ length: compartment.fields?.length }, (_, i) => (
                                                            <option key={i + 1} value={i + 1}>
                                                              {i + 1}
                                                            </option>
                                                          ))}
                                                        </select>

                                                      </div>

                                                      {compartment.layout_type === "columns" && (
                                                        <div key={fieldIndex} className="flex-column">
                                                          <label className="form-label">Column Number</label>
                                                          <select
                                                            type="number"
                                                            name="column_position"
                                                            value={field.column_position}
                                                            onChange={(e) =>
                                                              handleFieldChange(e, originalSectionIndex, compIndex, fieldIndex)
                                                            }
                                                            className="form-input-date"
                                                          >
                                                            <option value=''>Select Column No.</option>
                                                            {Array.from({ length: compartment.columns }, (_, i) => (
                                                              <option key={i + 1} value={i + 1}>
                                                                {i + 1}
                                                              </option>
                                                            ))}
                                                          </select>
                                                        </div>
                                                      )}

                                                      <div className="flex-column">
                                                        <label className="form-label">Category</label>
                                                        <input
                                                          type="text"
                                                          name="category"
                                                          value={field.category}
                                                          onChange={(e) => handleFieldChange(e, originalSectionIndex, compIndex, fieldIndex)}
                                                          className="form-input"
                                                        />
                                                      </div>

                                                      <div className="flex-column">
                                                        <div className="flex-row justify-between" style={{ gap: '10px' }}>
                                                          <div className="flex-column" style={{ width: '70%' }}>
                                                            <label className="form-label">Label</label>
                                                            <input
                                                              type="text"
                                                              name="label"
                                                              value={field.label}
                                                              onChange={(e) => handleFieldChange(e, originalSectionIndex, compIndex, fieldIndex)}
                                                              className="form-input-date"
                                                              placeholder="Label"
                                                            />
                                                          </div>

                                                          <div className="flex-column" style={{ width: '30%' }}>
                                                            <label className="form-label">Alignment</label>
                                                            <select
                                                              name="label_alignment"
                                                              value={field.label_alignment}
                                                              onChange={(e) => handleFieldChange(e, originalSectionIndex, compIndex, fieldIndex)}
                                                              className="form-input-date"
                                                            >
                                                              {alignmentChoices?.map(al => (
                                                                <option key={al.value} value={al.value}>{al.label}</option>
                                                              ))}
                                                            </select>
                                                          </div>
                                                        </div>
                                                      </div>

                                                      <div className="flex-column">
                                                        <div className="flex-row justify-between" style={{ gap: '10px' }}>
                                                          <div className="flex-column" style={{ width: '70%' }}>
                                                            <label className="form-label">Value</label>
                                                            <input
                                                              type="text"
                                                              name="value_key"
                                                              value={field.value_key}
                                                              onChange={(e) => handleFieldChange(e, originalSectionIndex, compIndex, fieldIndex)}
                                                              className="form-input-date"
                                                              placeholder="Value"
                                                            />
                                                          </div>

                                                          <div className="flex-column" style={{ width: '30%' }}>
                                                            <label className="form-label">Alignment</label>
                                                            <select
                                                              name="value_alignment"
                                                              value={field.value_alignment}
                                                              onChange={(e) => handleFieldChange(e, originalSectionIndex, compIndex, fieldIndex)}
                                                              className="form-input-date"
                                                            >
                                                              {alignmentChoices?.map(al => (
                                                                <option key={al.value} value={al.value}>{al.label}</option>
                                                              ))}
                                                            </select>
                                                          </div>

                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </li>
                                              </div>
                                            ))
                                          )
                                          :
                                          (<p className="text-center mt-2 mb-2">No Fields Selected</p>)

                                        }
                                      </ol>

                                      <div className="flex-row">
                                        <hr className="line" />
                                        <button
                                          type='button'
                                          title="Add Field"
                                          className=" flex-row jd-heading-main font-weight600 gap-2"
                                          onClick={() => addFieldToCompartment(originalSectionIndex, compIndex)}
                                        >
                                          <AddwithBlueCircle /> <span className="w-max-content">{`Add Fields in Compartment ${compIndex + 1} `}</span>
                                        </button>
                                      </div>
                                    </div>
                                  )
                                  )
                                ) : (
                                  <p className="text-center mt-2 mb-2">No Compartment Selected</p>
                                )
                              }
                            </ol>

                            <div className="flex-row">
                              <hr className="line" />
                              <button
                                type='button'
                                title="Add Comparment"
                                className=" flex-row jd-heading-main font-weight600 gap-2"
                                onClick={() => addCompartment(originalSectionIndex)}
                              >
                                <AddwithBlueCircle /> <span className="w-max-content">Add Compartment</span>
                              </button>
                            </div>

                          </div>
                        )
                      })
                    }
                  </ol>

                  <div className="flex-row">
                    <hr className="line" />
                    <button
                      type='button'
                      title="Add Comparment"
                      className=" flex-row jd-heading-main font-weight600 gap-2"
                      onClick={() => addSection()}
                    >
                      <AddwithBlueCircle /> <span className="w-max-content">Add Section</span>
                    </button>
                  </div>
                </>}
                {formData.body_display && <>
                  <div className="jd-heading-outer heading-bg-color-white">
                    <div className="jd-heading-outer-flex">
                      <h2 className="jd-heading-main font-weight600  font-size-heading">
                        Body Section Configuration
                      </h2>
                    </div>
                    <div>
                      <div className="jd-heading-bottom-bold"></div>
                      <div className="jd-heading-bottom-light"></div>
                    </div>
                  </div>
                  {

                    formData.sections.length > 0 && formData.sections
                      ?.filter(sec => sec.section_type === "body")
                      .map((section, sectionIndex) => {
                        const originalSectionIndex = formData.sections.findIndex(sec => sec === section);

                        return (
                          <div key={originalSectionIndex}>

                            <div className="flex-column">
                              <label className="form-label">Title</label>
                              <input
                                type="text"
                                name="title"
                                value={section.title}
                                onChange={(e) => handleSectionChange(e, originalSectionIndex)}
                                className="form-input"
                              />
                            </div>
                          </div>
                        )
                      })}
                </>
                }



                {formData.ender_display && <>
                  <div className="jd-heading-outer heading-bg-color-white">
                    <div className="jd-heading-outer-flex">
                      <h2 className="jd-heading-main font-weight600  font-size-heading">
                        Ender Section Configuration
                      </h2>
                    </div>
                    <div>
                      <div className="jd-heading-bottom-bold"></div>
                      <div className="jd-heading-bottom-light"></div>
                    </div>
                  </div>
                  {
                    formData.sections
                      ?.filter((sec) => sec.section_type === "ender")
                      .map((section, sectionIndex) => {

                        const originalIndex = formData.sections.findIndex(sec => sec === section);

                        return (
                          <div key={originalIndex}>


                            <div className="form-flex-wrap" >
                              <div className="flex-column">
                                <label className="form-labels font-weight500 font-size-subheading">
                                  Title
                                </label>
                                <input
                                  type="text"
                                  name="title"
                                  value={section.title}
                                  onChange={(e) => handleSectionChange(e, originalIndex)}
                                  className="form-input"
                                />
                              </div>

                              <div className="flex-column">
                                <label className="form-labels font-weight500 font-size-subheading">
                                  Ender Type
                                </label>
                                <select
                                  name="ender_type"
                                  value={section.ender_config?.ender_type || ""}
                                  onChange={(e) => handleEnderConfigChange(e, originalIndex)}
                                  className="form-input"
                                >
                                  <option value="signature">Signature</option>
                                  <option value="note">Note</option>
                                  <option value="default">Default Message</option>
                                </select>
                              </div>
                            </div>




                            {section.ender_config?.ender_type === "signature" && (
                              <>
                                <div className="form-flex-wrap ">
                                  <div className="flex-column">
                                    <label className="form-label">Authority Signatory</label>
                                    <select
                                      name="signature_authority"
                                      value={section.ender_config?.signature_authority || ""}
                                      onChange={(e) => handleEnderConfigChange(e, originalIndex)}
                                      className="form-input"
                                    >
                                      {empList
                                        .sort((a, b) => a.emp_code - b.emp_code)
                                        .map((i, index) => (
                                          <option key={i.emp_code} value={i.emp_code}>
                                            {i.name} - {i.emp_code}
                                          </option>
                                        ))}
                                    </select>
                                  </div>

                                  <div className="flex-column">
                                    <label className="form-label">Signature Position</label>
                                    <select
                                      name="authority_name_position"
                                      value={section.ender_config?.authority_name_position || ""}
                                      onChange={(e) => handleEnderConfigChange(e, originalIndex)}
                                      className="form-input-date"
                                    >
                                      <option value="top">Top</option>
                                      <option value="bottom">Bottom</option>
                                    </select>
                                  </div>
                                  <div className="flex-column">
                                    <label className="form-label">Signature Alignment</label>
                                    <select
                                      name="authority_name_alignment"
                                      value={section.ender_config?.authority_name_alignment || ""}
                                      onChange={(e) => handleEnderConfigChange(e, originalIndex)}
                                      className="form-input-date"
                                    >
                                      <option value="left">Left</option>
                                      <option value="center">Center</option>
                                      <option value="right">Right</option>
                                    </select>
                                  </div>
                                </div>
                                <div className="flex-column">
                                  <div className="form-flex-wrap ">

                                    <div className="flex-column">
                                      <div className="flex-row">

                                        <div className="checkbox-toggle">
                                          <input
                                            type="checkbox"
                                            name="show_for_name"
                                            checked={section.ender_config?.show_for_name || false}
                                            onChange={(e) => handleEnderConfigChange(e, originalIndex)}
                                            id="showForName"
                                          />
                                          <label htmlFor="showForName"></label>
                                        </div>
                                        <hr className="field-cont-hr" />
                                        <label
                                          htmlFor="showForName"
                                          className="font-weight500 font-size-subheading"
                                        >
                                          {section.ender_config?.show_for_name
                                            ? "Show"
                                            : "Hide"} Custom For Name
                                        </label>
                                      </div>
                                      {section.ender_config?.show_for_name &&
                                        <div className="flex-row">
                                          <input
                                            id={`for_name_${originalIndex} `}
                                            name="for_name"
                                            type="text"
                                            className="form-input"
                                            value={section.ender_config?.for_name}
                                            placeholder="For Name"
                                            onChange={(e) => handleEnderConfigChange(e, originalIndex)}
                                          />
                                          {/* <label htmlFor={`for_name_${ sectionIndex } `}>ss</label> */}
                                        </div>}
                                    </div>
                                    {section.ender_config?.show_for_name &&
                                      (
                                        <>
                                          <div className="flex-column">
                                            <label className="form-label">For Name Position</label>
                                            <select
                                              name="for_name_position"
                                              value={section.ender_config?.for_name_position || ""}
                                              onChange={(e) => handleEnderConfigChange(e, originalIndex)}
                                              className="form-input-date"
                                            >
                                              <option value="top">Top</option>
                                              <option value="bottom">Bottom</option>
                                            </select>
                                          </div>
                                          <div className="flex-column">
                                            <label className="form-label">For Name Alignment</label>
                                            <select
                                              name="for_name_alignment"
                                              value={section.ender_config?.for_name_alignment || ""}
                                              onChange={(e) => handleEnderConfigChange(e, originalIndex)}
                                              className="form-input-date"
                                            >
                                              <option value="left">Left</option>
                                              <option value="center">Center</option>
                                              <option value="right">Right</option>
                                            </select>
                                          </div>
                                        </>
                                      )
                                    }
                                  </div>

                                  <div className="flex-row">
                                    <div className="checkbox-toggle">
                                      <input
                                        type="checkbox"
                                        name="show_assigning_authority"
                                        onChange={(e) => handleEnderConfigChange(e, originalIndex)}
                                        checked={section.ender_config?.show_assigning_authority || false}
                                        id="showAssigningAuthorityName"
                                      // checked={section.ender_config?.show_authority_designation || false}
                                      // onChange={(e) => handleEnderConfigChange(e, sectionIndex)}
                                      // id={`showAuthorityDesignation - ${ sectionIndex } `}
                                      />
                                      <label htmlFor="showAssigningAuthorityName"></label>
                                    </div>
                                    <hr className="field-cont-hr" />
                                    <label
                                      htmlFor="showAssigningAuthorityName"
                                      className="font-weight500 font-size-subheading"
                                    >
                                      {section.ender_config?.show_assigning_authority ? "Show" : "Hide"} Signatory Authority Details
                                    </label>
                                  </div>
                                </div>


                                {section.ender_config?.show_assigning_authority &&
                                  <>
                                    <div className="flex-row justify-between">
                                      <div className="flex-row">
                                        <div className="checkbox-toggle">
                                          <input
                                            type="checkbox"
                                            name="show_authority_name"
                                            checked={section.ender_config?.show_authority_name || false}
                                            id="showAuthorityName"
                                            onChange={(e) => handleEnderConfigChange(e, originalIndex)}
                                          />
                                          <label htmlFor="showAuthorityName"></label>
                                        </div>
                                        <hr className="field-cont-hr" />
                                        <label
                                          htmlFor="showAuthorityName"
                                          className="font-weight500 font-size-subheading"
                                        >
                                          {section.ender_config?.show_authority_name
                                            ? "Show"
                                            : "Hide"} Authority Name
                                        </label>
                                      </div>
                                      {section.ender_config?.show_authority_name &&
                                        (
                                          <>
                                            <div className="flex-column">
                                              <label className="form-label">Authority Name Position</label>
                                              <select
                                                name="authority_name_position"
                                                value={section.ender_config?.authority_name_position || ""}
                                                onChange={(e) => handleEnderConfigChange(e, originalIndex)}
                                                className="form-input-date"
                                              >
                                                <option value="top">Top</option>
                                                <option value="bottom">Bottom</option>
                                              </select>
                                            </div>
                                            <div className="flex-column">
                                              <label className="form-label">Authority Name Alignment</label>
                                              <select
                                                name="authority_name_alignment"
                                                value={section.ender_config?.authority_name_alignment || ""}
                                                onChange={(e) => handleEnderConfigChange(e, originalIndex)}
                                                className="form-input-date"
                                              >
                                                <option value="left">Left</option>
                                                <option value="center">Center</option>
                                                <option value="right">Right</option>
                                              </select>
                                            </div>
                                          </>
                                        )
                                      }

                                    </div>
                                    <div className="flex-row justify-between">
                                      <div className="flex-row">
                                        <div className="checkbox-toggle">
                                          <input
                                            type="checkbox"
                                            name="show_authority_designation"
                                            checked={section.ender_config?.show_authority_designation || false}
                                            id="showAuthorityDesignation"
                                            onChange={(e) => handleEnderConfigChange(e, originalIndex)}
                                          />
                                          <label htmlFor="showAuthorityDesignation"></label>
                                        </div>
                                        <hr className="field-cont-hr" />
                                        <label
                                          htmlFor="showAuthorityDesignation"
                                          className="font-weight500 font-size-subheading"
                                        >
                                          {section.ender_config?.show_authority_designation
                                            ? "Show"
                                            : "Hide"} Authority Designation
                                        </label>
                                      </div>
                                      {
                                        section.ender_config?.show_authority_designation && (
                                          <>
                                            <div className="flex-column">
                                              <label className="form-label">Authority Designation Position</label>
                                              <select
                                                name="authority_designation_position"
                                                value={section.ender_config?.authority_designation_position || ""}
                                                onChange={(e) => handleEnderConfigChange(e, originalIndex)}
                                                className="form-input-date"
                                              >
                                                <option value="top">Top</option>
                                                <option value="bottom">Bottom</option>
                                              </select>
                                            </div>
                                            <div className="flex-column">
                                              <label className="form-label">Authority Designation Alignment</label>
                                              <select
                                                name="authority_designation_alignment"
                                                value={section.ender_config?.authority_designation_alignment || ""}
                                                onChange={(e) => handleEnderConfigChange(e, originalIndex)}
                                                className="form-input-date"
                                              >
                                                <option value="left">Left</option>
                                                <option value="center">Center</option>
                                                <option value="right">Right</option>
                                              </select>
                                            </div>
                                          </>
                                        )
                                      }
                                    </div>
                                  </>
                                }
                              </>
                            )
                            }

                            {
                              section.ender_config?.ender_type === "note" && (
                                <div className="form-flex-wrap">
                                  <div className="flex-column" style={{ width: "100%" }}>
                                    <label className="form-label">Note Text</label>
                                    <textarea
                                      name="note_text"
                                      value={section.ender_config?.note_text || ""}
                                      onChange={(e) => handleEnderConfigChange(e, originalIndex)}
                                      className="form-input"
                                      rows={4}
                                    />
                                  </div>
                                </div>
                              )
                            }

                            {
                              section.ender_config?.ender_type === "default" && (
                                <div className="form-flex-wrap">
                                  <div className="flex-column" style={{ width: "100%" }}>
                                    <label className="form-label">Default Message :</label>
                                    <b>*This is a software generated slip. No signature required*</b>
                                    {/* <input
                                    type="text"
                                    className="form-input"
                                    readOnly
                                    value={`* This is a software generated slip.No signature required * `}
                                  /> */}
                                  </div>
                                </div>
                              )
                            }
                          </div>
                        )
                      })

                  }
                </>
                }

              </form>

              <div className="button-models">
                <button
                  className="model-button model-button-cancel font-weight500"
                  onClick={handleClose}
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  className="model-button model-button-leave font-weight500 font-size-heading"
                  disabled={loading}
                  onClick={handleSubmit}
                >
                  {loading ? "Updating..." : "Update Slip Template"}
                </button>
              </div>
            </div>
            <p className="error-message font-size-text">
              {isSubmitted && Object.keys(errors).length > 0 && (
                Object.keys(errors).length > 5 ? (
                  <h5 className="text-center">Please fill all mandatory fields!</h5>
                ) : (
                  <h6 className="text-center">
                    {Object.keys(errors)
                      ?.map((field) =>
                        field
                          .replace(/_/g, ' ')
                          .replace(/\b\w/g, (char) => char.toUpperCase())
                      )
                      .join(', ') + ' are required!'}
                  </h6>
                )
              )}
            </p>
          </div>
        </Modal.Body >
      </Modal >

      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
};

const DeleteSlipBuildDetails = ({ i, getSlipBuilderData }) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  };
  const [loading, setLoading] = useState(false);

  const handleDelete = async (e) => {
    e.preventDefault();
    const loadingToastId = toast.loading("Loading: Please wait...");
    try {
      const res = await axios.delete(
        `${BASE_URL}/wfm/slip-builder-update/${i?.id}/`
      );
      if (res.status === 200) {
        await getSlipBuilderData();
        setShow(false);
        toast.success("Slip Template Deleted Successfully!");
      } else {
        alert(res);
      }
    } catch (err) {
      handleErrorToast(err, loadingToastId);
    } finally {
      setLoading(false);
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button className="model-delete-button" onClick={handleShow}>
        <DeleteDustbin />
      </button>
      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Slip Template </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            Are You Sure You Want to delete slip template of{" "}
            <b>{i?.name}</b>
            <div className="button-models">
              <button
                className="model-button model-button-cancel   font-weight500    "
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                onClick={handleDelete}
                className="model-button   font-weight500    model-button-delete"
                disabled={loading}
              >
                {loading ? "Deleting..." : "Delete"}
              </button>
            </div>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
};

const ViewSlipBuilder = ({
  buttonDisplay,
  buttonDisplayName,
  i,
  onClose,
}) => {
  const [pages, setPages] = useState([]);
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setShow(false);
    if (onClose) onClose();
  };

  const handleShow = () => {
    if (i?.letter_template) {
      getLetterTemplateData()
    }
    setShow(true);
  };

  const [letterTemplateData, setLetterTemplateData] = useState({});
  const [buffer1, setBuffering1] = useState(false);
  const getLetterTemplateData = async () => {
    setBuffering1(true);
    try {
      const template = await axios.get(`${BASE_URL}/wfm/letter-builder-template-byid/${i?.letter_template}/`);
      setLetterTemplateData(template.data);
    } catch (err) {
      if (!i?.letter_template) {
        toast.warning("Select/Give Letter Template ID ");
      } else {
        handleErrorToast(err);
      }
    } finally {
      setBuffering1(false);
    }
  };



  const defaultButton = (
    <button
      type="button"
      title="Preview"
      className="model-button model-button-cancel"
      onClick={handleShow}
    >
      <Eye /> {buttonDisplayName || "Preview"}
    </button>
  );

  const buttonVariants = {
    'Eye': (
      <button
        type="button"
        title={buttonDisplayName || "View"}
        onClick={handleShow}
      >
        <Eye />
      </button>
    ),
    'Name': (
      <button
        type="button"
        title={buttonDisplayName || "View"}
        style={{ paddingLeft: "5px", color: "blue", fontSize: "14px" }}
        onClick={handleShow}
      >
        {buttonDisplayName || "View"}
      </button>
    ),
    'Eye-Name': (
      <button
        type="button"
        title={buttonDisplayName || "View"}
        style={{ paddingLeft: "5px", color: "blue", fontSize: "14px" }}
        onClick={handleShow}
      >
        <Eye /> {buttonDisplayName || "View"}
      </button>
    ),

    'Model-Eye': (
      <button
        type="button"
        title={buttonDisplayName || "View"}
        className="model-button model-button-cancel"
        onClick={handleShow}
      >
        <Eye />
      </button>
    ),
    'Model-Name': (
      <button
        type="button"
        className="model-button model-button-cancel"
        onClick={handleShow}
      >
        {buttonDisplayName || "View"}
      </button>
    ),
    'Model-Eye-Name': (
      <button
        type="button"
        className="model-button model-button-cancel"
        onClick={handleShow}
      >
        <Eye /> {buttonDisplayName || "View"}
      </button>
    ),
  };
  const fontSize = "13";
  const ref = useRef();
  const printButton = (
    <ReactToPrint
      bodyClass="print-agreement"
      content={() => ref.current}
      trigger={() => (
        <button
          className="model-button model-button-black"
          style={{ marginLeft: "10px" }}
        >
          <Printer /> Print
        </button>
      )}
    />
  );


  const content = (
    <div
      className="content-container"
      style={{
        overflow: "hidden",
        wordWrap: "break-word",
      }}
    >
      <div
        className="printSlip-header-left-text font-size-heading"
        style={{ padding: "0px", fontSize: "17px" }}
      >
        {i?.name}
      </div>

      {i?.sections
        ?.filter((sec) => sec.section_type === "starter")
        ?.map((section, sectionIndex) => (
          <div key={sectionIndex}>
            {section?.compartments?.map((compartment, compIndex) => {

              const fields = [...(compartment.fields || [])].sort(
                (a, b) => (a.order || 0) - (b.order || 0)
              );

              if (compartment.layout_type === "full") {

                return (
                  <>
                    <div
                      key={compIndex}
                      className="salaryslip-header-section"
                      style={{ display: "flex", flexDirection: "column" }}
                    >
                      {fields.map((field, fIndex) => (
                        <div
                          key={fIndex}
                          style={{
                            display: "flex",
                            // gap: '10px',
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <div
                            className=""
                            style={{ textAlign: field.label_alignment || "left" }}
                          >
                            <div className="printSlip-heading-black   font-weight600 font-size-subheading">
                              {field.label}:
                            </div>
                          </div>
                          <div
                            className=""
                            style={{ textAlign: field.value_alignment || "left" }}
                          >
                            <div className="printSlip-heading-black1 font-weight400 font-s-16px">
                              {field.value_key || "-"}
                            </div>
                          </div>
                        </div>
                      ))}

                    </div>
                    <div className='salaryslip-hr'></div>
                  </>
                );
              }

              if (compartment.layout_type === "columns") {

                return (
                  <>
                    <div
                      key={compIndex}
                      className="salaryslip-header-section"
                      style={{
                        display: "grid",
                        gridTemplateColumns: `repeat(${compartment.columns}, 1fr)`,
                        gap: "20px",
                      }}
                    >
                      {Array.from({ length: compartment.columns }).map((_, columnIndex) => (
                        <>
                          <div key={columnIndex} className="printSlip-column">
                            {fields
                              .filter((f) => f.column_position === columnIndex + 1)
                              .map((field, fIndex) => (
                                <div key={fIndex} className="printSlip-row">
                                  <div className="printSlip-label">{field.label} :</div>
                                  <div className={`printSlip-value ${field.value_key ? "text-capitalize" : ""
                                    }`} >
                                    {field.value_key || "-"}
                                  </div>
                                </div>
                              ))}
                          </div>

                          {/* {columnIndex < compartment.columns - 1 && (
                                                                <div className="vertical-divider"></div>
                                                            )} */}

                        </>
                      ))}



                    </div>
                    <div className='horizontal-divider'></div>
                  </>
                );
              }

              return null;
            })}
          </div>
        ))
      }
    </div>
  );


  return (
    <>
      {buttonVariants[buttonDisplay] || defaultButton}
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Modal show={show} onHide={handleClose}
        size="xl"
        centered
        dialogClassName="flex justify-center lettertemp-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Slip Template
            <span className="dynamic-modal-title">
              {''}
            </span>
          </Modal.Title>
          {/* {printButton} */}
        </Modal.Header>
        <Modal.Body>
          <LetterPreview
            ref={ref}
            letterTemplateData={letterTemplateData}
            fontSize={fontSize}
            buffer1={buffer1}
          >
            {content}
          </LetterPreview>
        </Modal.Body>
        <Modal.Footer className="modal-btn-pos">
          <button
            className="justify-center model-button model-button-cancel font-weight500"
            onClick={handleClose}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal >


    </>
  );
};

export {
  AddSlipBuilderCategory,
  UpdateSlipBuilderCategory,
  DeleteSlipBuilderCategory,

  AddSlipBuildDetails,
  UpdateSlipBuildDetails,
  DeleteSlipBuildDetails,
  ViewSlipBuilder
};
